(() => {
  let a = document.querySelectorAll(".js-parallax");
  var t = () => {
    a.forEach((a) => {
      var t,
        { top: e, height: r } = a.getBoundingClientRect(),
        { clientHeight: l, scrollY: p } = document,
        r = e + r;
      e < p + l &&
        p < r + p &&
        ((e = e - l),
        (l = parseInt((p - e) / ((r - e) / 100))),
        a.dataset.parallaxProperty,
        (p = (parseInt(a.dataset.parallaxPropertyValue) / 100) * l),
        (r = a.dataset.parallaxSteps)
          ? (([e, r] = r.split(", ").map(Number)),
            (t = e < r ? (100 / (r - e)) * (l - e) : 0),
            (t =
              e < r
                ? (parseInt(a.dataset.parallaxPropertyValue) / 100) * t
                : 0),
            (a.style.transform =
              e <= l && l <= r
                ? `translate3d(0px, ${t}px, 0px)`
                : r < l
                  ? `translate3d(0px, ${parseInt(a.dataset.parallaxPropertyValue)}px, 0px)`
                  : "translate3d(0px, 0px, 0px)"))
          : (a.style.transform = `translate3d(0px, ${p}px, 0px)`));
    });
  };
  window.addEventListener("scroll", t),
    t(),
    document.addEventListener("shopify:section:load", t);
})();
var Swiper = (() => {
  function a(e) {
    return (
      null !== e &&
      "object" == typeof e &&
      "constructor" in e &&
      e.constructor === Object
    );
  }
  function i(t, s) {
    void 0 === t && (t = {}),
      void 0 === s && (s = {}),
      Object.keys(s).forEach((e) => {
        void 0 === t[e]
          ? (t[e] = s[e])
          : a(s[e]) && a(t[e]) && 0 < Object.keys(s[e]).length && i(t[e], s[e]);
      });
  }
  let t = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector: () => null,
    querySelectorAll: () => [],
    getElementById: () => null,
    createEvent: () => ({ initEvent() {} }),
    createElement: () => ({
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName: () => [],
    }),
    createElementNS: () => ({}),
    importNode: () => null,
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function I() {
    var e = "undefined" != typeof document ? document : {};
    return i(e, t), e;
  }
  let B = {
    document: t,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle: () => ({ getPropertyValue: () => "" }),
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia: () => ({}),
    requestAnimationFrame: (e) =>
      "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
    cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };
  function g() {
    var e = "undefined" != typeof window ? window : {};
    return i(e, B), e;
  }
  function w(e, t) {
    return void 0 === t && (t = 0), setTimeout(e, t);
  }
  function b() {
    return Date.now();
  }
  function _(e, t) {
    void 0 === t && (t = "x");
    var s = g();
    let a, i, r;
    e = ((e) => {
      var t = g();
      let s;
      return (s =
        (s =
          !(s = t.getComputedStyle ? t.getComputedStyle(e, null) : s) &&
          e.currentStyle
            ? e.currentStyle
            : s) || e.style);
    })(e);
    return (
      s.WebKitCSSMatrix
        ? (6 < (i = e.transform || e.webkitTransform).split(",").length &&
            (i = i
              .split(", ")
              .map((e) => e.replace(",", "."))
              .join(", ")),
          (r = new s.WebKitCSSMatrix("none" === i ? "" : i)))
        : ((r =
            e.MozTransform ||
            e.OTransform ||
            e.MsTransform ||
            e.msTransform ||
            e.transform ||
            e
              .getPropertyValue("transform")
              .replace("translate(", "matrix(1, 0, 0, 1,")),
          (a = r.toString().split(","))),
      "x" === t &&
        (i = s.WebKitCSSMatrix
          ? r.m41
          : 16 === a.length
            ? parseFloat(a[12])
            : parseFloat(a[4])),
      (i =
        "y" === t
          ? s.WebKitCSSMatrix
            ? r.m42
            : 16 === a.length
              ? parseFloat(a[13])
              : parseFloat(a[5])
          : i) || 0
    );
  }
  function d(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function y(e) {
    let a = Object(arguments.length <= 0 ? void 0 : e),
      t = ["__proto__", "constructor", "prototype"];
    for (let e = 1; e < arguments.length; e += 1) {
      var i = e < 0 || arguments.length <= e ? void 0 : arguments[e];
      if (
        null != i &&
        ((s = i),
        !("undefined" != typeof window && void 0 !== window.HTMLElement
          ? s instanceof HTMLElement
          : s && (1 === s.nodeType || 11 === s.nodeType)))
      ) {
        let s = Object.keys(Object(i)).filter((e) => t.indexOf(e) < 0);
        for (let e = 0, t = s.length; e < t; e += 1) {
          var r = s[e],
            l = Object.getOwnPropertyDescriptor(i, r);
          void 0 !== l &&
            l.enumerable &&
            (d(a[r]) && d(i[r])
              ? i[r].__swiper__
                ? (a[r] = i[r])
                : y(a[r], i[r])
              : d(a[r]) || !d(i[r]) || ((a[r] = {}), i[r].__swiper__)
                ? (a[r] = i[r])
                : y(a[r], i[r]));
        }
      }
    }
    var s;
    return a;
  }
  function L(e, t, s) {
    e.style.setProperty(t, s);
  }
  function T(e) {
    let { swiper: s, targetPosition: a, side: i } = e,
      r = g(),
      l = -s.translate,
      n,
      o = null,
      d = s.params.speed,
      p =
        ((s.wrapperEl.style.scrollSnapType = "none"),
        r.cancelAnimationFrame(s.cssModeFrameID),
        a > l ? "next" : "prev"),
      c = (e, t) => ("next" === p && t <= e) || ("prev" === p && e <= t),
      u = () => {
        (n = new Date().getTime()), null === o && (o = n);
        var e = Math.max(Math.min((n - o) / d, 1), 0),
          e = 0.5 - Math.cos(e * Math.PI) / 2;
        let t = l + e * (a - l);
        c(t, a) && (t = a),
          s.wrapperEl.scrollTo({ [i]: t }),
          c(t, a)
            ? ((s.wrapperEl.style.overflow = "hidden"),
              (s.wrapperEl.style.scrollSnapType = ""),
              setTimeout(() => {
                (s.wrapperEl.style.overflow = ""),
                  s.wrapperEl.scrollTo({ [i]: t });
              }),
              r.cancelAnimationFrame(s.cssModeFrameID))
            : (s.cssModeFrameID = r.requestAnimationFrame(u));
      };
    u();
  }
  function r(e) {
    return (
      e.querySelector(".swiper-slide-transform") ||
      (e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform")) ||
      e
    );
  }
  function A(e, t) {
    return (
      void 0 === t && (t = ""), [...e.children].filter((e) => e.matches(t))
    );
  }
  function P(e) {
    try {
      console.warn(e);
    } catch (e) {}
  }
  function p(e, t) {
    void 0 === t && (t = []);
    e = document.createElement(e);
    return (
      e.classList.add(
        ...(Array.isArray(t)
          ? t
          : (void 0 === t ? "" : t)
              .trim()
              .split(" ")
              .filter((e) => !!e.trim())),
      ),
      e
    );
  }
  function C(e, t) {
    return g().getComputedStyle(e, null).getPropertyValue(t);
  }
  function f(e) {
    let t,
      s = e;
    if (s) {
      for (t = 0; null !== (s = s.previousSibling); )
        1 === s.nodeType && (t += 1);
      return t;
    }
  }
  function v(e, t) {
    var s = [];
    let a = e.parentElement;
    for (; a; ) (t && !a.matches(t)) || s.push(a), (a = a.parentElement);
    return s;
  }
  function x(s, a) {
    a &&
      s.addEventListener("transitionend", function e(t) {
        t.target === s &&
          (a.call(s, t), s.removeEventListener("transitionend", e));
      });
  }
  function O(e, t, s) {
    var a = g();
    return s
      ? e["width" === t ? "offsetWidth" : "offsetHeight"] +
          parseFloat(
            a
              .getComputedStyle(e, null)
              .getPropertyValue("width" === t ? "margin-right" : "margin-top"),
          ) +
          parseFloat(
            a
              .getComputedStyle(e, null)
              .getPropertyValue(
                "width" === t ? "margin-left" : "margin-bottom",
              ),
          )
      : e.offsetWidth;
  }
  function S(e) {
    return (Array.isArray(e) ? e : [e]).filter((e) => !!e);
  }
  let s, e, l;
  function u() {
    return (s =
      s ||
      ((e = g()),
      {
        smoothScroll:
          (t = I()).documentElement &&
          t.documentElement.style &&
          "scrollBehavior" in t.documentElement.style,
        touch: !!(
          "ontouchstart" in e ||
          (e.DocumentTouch && t instanceof e.DocumentTouch)
        ),
      }));
    var e, t;
  }
  function F(c) {
    return (
      void 0 === c && (c = {}),
      (e =
        e ||
        (() => {
          var e = (void 0 === c ? {} : c).userAgent,
            t = u(),
            s = (r = g()).navigator.platform,
            e = e || r.navigator.userAgent,
            a = { ios: !1, android: !1 },
            i = r.screen.width,
            r = r.screen.height,
            l = e.match(/(Android);?[\s\/]+([\d.]+)?/);
          let n = e.match(/(iPad).*OS\s([\d_]+)/);
          var o = e.match(/(iPod)(.*OS\s([\d_]+))?/),
            d = !n && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            p = "Win32" === s,
            s = "MacIntel" === s;
          return (
            !n &&
              s &&
              t.touch &&
              0 <=
                [
                  "1024x1366",
                  "1366x1024",
                  "834x1194",
                  "1194x834",
                  "834x1112",
                  "1112x834",
                  "768x1024",
                  "1024x768",
                  "820x1180",
                  "1180x820",
                  "810x1080",
                  "1080x810",
                ].indexOf(i + "x" + r) &&
              (n = (n = e.match(/(Version)\/([\d.]+)/)) || [0, 1, "13_0_0"]),
            l && !p && ((a.os = "android"), (a.android = !0)),
            (n || d || o) && ((a.os = "ios"), (a.ios = !0)),
            a
          );
        })())
    );
  }
  function N() {
    return (l =
      l ||
      (() => {
        let t = g(),
          e = F(),
          a = !1;
        function s() {
          var e = t.navigator.userAgent.toLowerCase();
          return (
            0 <= e.indexOf("safari") &&
            e.indexOf("chrome") < 0 &&
            e.indexOf("android") < 0
          );
        }
        if (s()) {
          let s = String(t.navigator.userAgent);
          if (s.includes("Version/")) {
            let [e, t] = s
              .split("Version/")[1]
              .split(" ")[0]
              .split(".")
              .map((e) => Number(e));
            a = e < 16 || (16 === e && t < 2);
          }
        }
        var i = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            t.navigator.userAgent,
          ),
          r = s();
        return {
          isSafari: a || r,
          needPerspectiveFix: a,
          need3dFix: r || (i && e.ios),
          isWebView: i,
        };
      })());
  }
  let V = {
      on(e, s, a) {
        let i = this;
        if (i.eventsListeners && !i.destroyed && "function" == typeof s) {
          let t = a ? "unshift" : "push";
          e.split(" ").forEach((e) => {
            i.eventsListeners[e] || (i.eventsListeners[e] = []),
              i.eventsListeners[e][t](s);
          });
        }
        return i;
      },
      once(a, i, e) {
        let r = this;
        return !r.eventsListeners || r.destroyed || "function" != typeof i
          ? r
          : ((l.__emitterProxy = i), r.on(a, l, e));
        function l() {
          r.off(a, l), l.__emitterProxy && delete l.__emitterProxy;
          for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
            t[s] = arguments[s];
          i.apply(r, t);
        }
      },
      onAny(e, t) {
        var s = this;
        return (
          s.eventsListeners &&
            !s.destroyed &&
            "function" == typeof e &&
            ((t = t ? "unshift" : "push"),
            s.eventsAnyListeners.indexOf(e) < 0) &&
            s.eventsAnyListeners[t](e),
          s
        );
      },
      offAny(e) {
        var t = this;
        return (
          t.eventsListeners &&
            !t.destroyed &&
            t.eventsAnyListeners &&
            0 <= (e = t.eventsAnyListeners.indexOf(e)) &&
            t.eventsAnyListeners.splice(e, 1),
          t
        );
      },
      off(e, a) {
        let i = this;
        return (
          !i.eventsListeners ||
            i.destroyed ||
            (i.eventsListeners &&
              e.split(" ").forEach((s) => {
                void 0 === a
                  ? (i.eventsListeners[s] = [])
                  : i.eventsListeners[s] &&
                    i.eventsListeners[s].forEach((e, t) => {
                      (e === a ||
                        (e.__emitterProxy && e.__emitterProxy === a)) &&
                        i.eventsListeners[s].splice(t, 1);
                    });
              })),
          i
        );
      },
      emit() {
        let i = this;
        if (i.eventsListeners && !i.destroyed && i.eventsListeners) {
          let e, s, a;
          for (var t = arguments.length, r = new Array(t), l = 0; l < t; l++)
            r[l] = arguments[l];
          (a =
            "string" == typeof r[0] || Array.isArray(r[0])
              ? ((e = r[0]), (s = r.slice(1, r.length)), i)
              : ((e = r[0].events), (s = r[0].data), r[0].context || i)),
            s.unshift(a),
            (Array.isArray(e) ? e : e.split(" ")).forEach((t) => {
              i.eventsAnyListeners &&
                i.eventsAnyListeners.length &&
                i.eventsAnyListeners.forEach((e) => {
                  e.apply(a, [t, ...s]);
                }),
                i.eventsListeners &&
                  i.eventsListeners[t] &&
                  i.eventsListeners[t].forEach((e) => {
                    e.apply(a, s);
                  });
            });
        }
        return i;
      },
    },
    H = (e, t, s) => {
      t && !e.classList.contains(s)
        ? e.classList.add(s)
        : !t && e.classList.contains(s) && e.classList.remove(s);
    },
    c = (e, t, s) => {
      t && !e.classList.contains(s)
        ? e.classList.add(s)
        : !t && e.classList.contains(s) && e.classList.remove(s);
    },
    n = (s, e) => {
      if (s && !s.destroyed && s.params) {
        let t = e.closest(
          s.isElement ? "swiper-slide" : "." + s.params.slideClass,
        );
        if (t) {
          let e = t.querySelector("." + s.params.lazyPreloaderClass);
          !e &&
            s.isElement &&
            (t.shadowRoot
              ? (e = t.shadowRoot.querySelector(
                  "." + s.params.lazyPreloaderClass,
                ))
              : requestAnimationFrame(() => {
                  t.shadowRoot &&
                    (e = t.shadowRoot.querySelector(
                      "." + s.params.lazyPreloaderClass,
                    )) &&
                    e.remove();
                })),
            e && e.remove();
        }
      }
    },
    o = (e, t) => {
      e.slides[t] &&
        (e = e.slides[t].querySelector('[loading="lazy"]')) &&
        e.removeAttribute("loading");
    },
    m = (n) => {
      if (n && !n.destroyed && n.params) {
        let l = n.params.lazyPreloadPrevNext,
          a = n.slides.length;
        if (a && l && !(l < 0)) {
          l = Math.min(l, a);
          let i =
              "auto" === n.params.slidesPerView
                ? n.slidesPerViewDynamic()
                : Math.ceil(n.params.slidesPerView),
            r = n.activeIndex;
          if (n.params.grid && 1 < n.params.grid.rows) {
            let s = r,
              a = [s - l];
            a.push(...Array.from({ length: l }).map((e, t) => s + i + t)),
              void n.slides.forEach((e, t) => {
                a.includes(e.column) && o(n, t);
              });
          } else {
            let s = r + i - 1;
            if (n.params.rewind || n.params.loop)
              for (let t = r - l; t <= s + l; t += 1) {
                let e = ((t % a) + a) % a;
                (e < r || e > s) && o(n, e);
              }
            else
              for (
                let e = Math.max(r - l, 0);
                e <= Math.min(s + l, a - 1);
                e += 1
              )
                e !== r && (e > s || e < r) && o(n, e);
          }
        }
      }
    },
    j = {
      updateSize: function () {
        var e = this;
        let t, s;
        var a = e.el;
        (t = null != e.params.width ? e.params.width : a.clientWidth),
          (s = null != e.params.height ? e.params.height : a.clientHeight),
          (0 === t && e.isHorizontal()) ||
            (0 === s && e.isVertical()) ||
            ((t =
              t -
              parseInt(C(a, "padding-left") || 0, 10) -
              parseInt(C(a, "padding-right") || 0, 10)),
            (s =
              s -
              parseInt(C(a, "padding-top") || 0, 10) -
              parseInt(C(a, "padding-bottom") || 0, 10)),
            Number.isNaN(t) && (t = 0),
            Number.isNaN(s) && (s = 0),
            Object.assign(e, {
              width: t,
              height: s,
              size: e.isHorizontal() ? t : s,
            }));
      },
      updateSlides: function () {
        let i = this;
        function d(e, t) {
          return parseFloat(e.getPropertyValue(i.getDirectionLabel(t)) || 0);
        }
        let r = i.params,
          {
            wrapperEl: e,
            slidesEl: t,
            size: l,
            rtlTranslate: s,
            wrongRTL: a,
          } = i,
          n = i.virtual && r.virtual.enabled,
          p = (n ? i.virtual : i).slides.length,
          c = A(t, `.${i.params.slideClass}, swiper-slide`),
          u = (n ? i.virtual.slides : c).length,
          m = [],
          h = [],
          f = [],
          v = r.slidesOffsetBefore,
          g =
            ("function" == typeof v && (v = r.slidesOffsetBefore.call(i)),
            r.slidesOffsetAfter);
        "function" == typeof g && (g = r.slidesOffsetAfter.call(i));
        var w = i.snapGrid.length,
          b = i.slidesGrid.length;
        let y = r.spaceBetween,
          T = -v,
          x = 0,
          S = 0;
        if (void 0 !== l) {
          "string" == typeof y && 0 <= y.indexOf("%")
            ? (y = (parseFloat(y.replace("%", "")) / 100) * l)
            : "string" == typeof y && (y = parseFloat(y)),
            (i.virtualSize = -y),
            c.forEach((e) => {
              s ? (e.style.marginLeft = "") : (e.style.marginRight = ""),
                (e.style.marginBottom = ""),
                (e.style.marginTop = "");
            }),
            r.centeredSlides &&
              r.cssMode &&
              (L(e, "--swiper-centered-offset-before", ""),
              L(e, "--swiper-centered-offset-after", ""));
          var E = r.grid && 1 < r.grid.rows && i.grid;
          let o;
          E ? i.grid.initSlides(c) : i.grid && i.grid.unsetSlides();
          var M =
            "auto" === r.slidesPerView &&
            r.breakpoints &&
            0 <
              Object.keys(r.breakpoints).filter(
                (e) => void 0 !== r.breakpoints[e].slidesPerView,
              ).length;
          for (let a = 0; a < u; a += 1) {
            let n;
            if (
              ((o = 0),
              c[a] && (n = c[a]),
              E && i.grid.updateSlide(a, n, c),
              !c[a] || "none" !== C(n, "display"))
            ) {
              if ("auto" === r.slidesPerView) {
                M && (c[a].style[i.getDirectionLabel("width")] = "");
                let t = getComputedStyle(n),
                  e = n.style.transform,
                  s = n.style.webkitTransform;
                if (
                  (e && (n.style.transform = "none"),
                  s && (n.style.webkitTransform = "none"),
                  r.roundLengths)
                )
                  o = i.isHorizontal() ? O(n, "width", !0) : O(n, "height", !0);
                else {
                  let s = d(t, "width"),
                    a = d(t, "padding-left"),
                    i = d(t, "padding-right"),
                    r = d(t, "margin-left"),
                    l = d(t, "margin-right"),
                    e = t.getPropertyValue("box-sizing");
                  if (e && "border-box" === e) o = s + r + l;
                  else {
                    let { clientWidth: e, offsetWidth: t } = n;
                    o = s + a + i + r + l + (t - e);
                  }
                }
                e && (n.style.transform = e),
                  s && (n.style.webkitTransform = s),
                  r.roundLengths && (o = Math.floor(o));
              } else
                (o = (l - (r.slidesPerView - 1) * y) / r.slidesPerView),
                  r.roundLengths && (o = Math.floor(o)),
                  c[a] && (c[a].style[i.getDirectionLabel("width")] = o + "px");
              c[a] && (c[a].swiperSlideSize = o),
                f.push(o),
                r.centeredSlides
                  ? ((T = T + o / 2 + x / 2 + y),
                    0 === x && 0 !== a && (T = T - l / 2 - y),
                    0 === a && (T = T - l / 2 - y),
                    Math.abs(T) < 0.001 && (T = 0),
                    r.roundLengths && (T = Math.floor(T)),
                    S % r.slidesPerGroup == 0 && m.push(T),
                    h.push(T))
                  : (r.roundLengths && (T = Math.floor(T)),
                    (S - Math.min(i.params.slidesPerGroupSkip, S)) %
                      i.params.slidesPerGroup ==
                      0 && m.push(T),
                    h.push(T),
                    (T = T + o + y)),
                (i.virtualSize += o + y),
                (x = o),
                (S += 1);
            }
          }
          if (
            ((i.virtualSize = Math.max(i.virtualSize, l) + g),
            s &&
              a &&
              ("slide" === r.effect || "coverflow" === r.effect) &&
              (e.style.width = i.virtualSize + y + "px"),
            r.setWrapperSize &&
              (e.style[i.getDirectionLabel("width")] =
                i.virtualSize + y + "px"),
            E && i.grid.updateWrapperSize(o, m),
            !r.centeredSlides)
          ) {
            let s = [];
            for (let t = 0; t < m.length; t += 1) {
              let e = m[t];
              r.roundLengths && (e = Math.floor(e)),
                m[t] <= i.virtualSize - l && s.push(e);
            }
            (m = s),
              1 < Math.floor(i.virtualSize - l) - Math.floor(m[m.length - 1]) &&
                m.push(i.virtualSize - l);
          }
          if (n && r.loop) {
            let a = f[0] + y;
            if (1 < r.slidesPerGroup) {
              let t = Math.ceil(
                  (i.virtual.slidesBefore + i.virtual.slidesAfter) /
                    r.slidesPerGroup,
                ),
                s = a * r.slidesPerGroup;
              for (let e = 0; e < t; e += 1) m.push(m[m.length - 1] + s);
            }
            for (
              let e = 0;
              e < i.virtual.slidesBefore + i.virtual.slidesAfter;
              e += 1
            )
              1 === r.slidesPerGroup && m.push(m[m.length - 1] + a),
                h.push(h[h.length - 1] + a),
                (i.virtualSize += a);
          }
          if ((0 === m.length && (m = [0]), 0 !== y)) {
            let t =
              i.isHorizontal() && s
                ? "marginLeft"
                : i.getDirectionLabel("marginRight");
            c.filter(
              (e, t) => !(r.cssMode && !r.loop) || t !== c.length - 1,
            ).forEach((e) => {
              e.style[t] = y + "px";
            });
          }
          if (r.centeredSlides && r.centeredSlidesBounds) {
            let t = 0,
              s =
                (f.forEach((e) => {
                  t += e + (y || 0);
                }),
                (t -= y) - l);
            m = m.map((e) => (e <= 0 ? -v : e > s ? s + g : e));
          }
          if (r.centerInsufficientSlides) {
            let t = 0,
              e =
                (f.forEach((e) => {
                  t += e + (y || 0);
                }),
                (t -= y),
                (r.slidesOffsetBefore || 0) + (r.slidesOffsetAfter || 0));
            if (t + e < l) {
              let s = (l - t - e) / 2;
              m.forEach((e, t) => {
                m[t] = e - s;
              }),
                h.forEach((e, t) => {
                  h[t] = e + s;
                });
            }
          }
          if (
            (Object.assign(i, {
              slides: c,
              snapGrid: m,
              slidesGrid: h,
              slidesSizesGrid: f,
            }),
            r.centeredSlides && r.cssMode && !r.centeredSlidesBounds)
          ) {
            L(e, "--swiper-centered-offset-before", -m[0] + "px"),
              L(
                e,
                "--swiper-centered-offset-after",
                i.size / 2 - f[f.length - 1] / 2 + "px",
              );
            let t = -i.snapGrid[0],
              s = -i.slidesGrid[0];
            (i.snapGrid = i.snapGrid.map((e) => e + t)),
              (i.slidesGrid = i.slidesGrid.map((e) => e + s));
          }
          if (
            (u !== p && i.emit("slidesLengthChange"),
            m.length !== w &&
              (i.params.watchOverflow && i.checkOverflow(),
              i.emit("snapGridLengthChange")),
            h.length !== b && i.emit("slidesGridLengthChange"),
            r.watchSlidesProgress && i.updateSlidesOffset(),
            i.emit("slidesUpdated"),
            !(n || r.cssMode || ("slide" !== r.effect && "fade" !== r.effect)))
          ) {
            let e = r.containerModifierClass + "backface-hidden",
              t = i.el.classList.contains(e);
            u <= r.maxBackfaceHiddenSlides
              ? t || i.el.classList.add(e)
              : t && i.el.classList.remove(e);
          }
        }
      },
      updateAutoHeight: function (e) {
        let t = this,
          s = [],
          a = t.virtual && t.params.virtual.enabled,
          i,
          r = 0;
        "number" == typeof e
          ? t.setTransition(e)
          : !0 === e && t.setTransition(t.params.speed);
        var l = (e) => (a ? t.slides[t.getSlideIndexByData(e)] : t.slides[e]);
        if ("auto" !== t.params.slidesPerView && 1 < t.params.slidesPerView)
          if (t.params.centeredSlides)
            (t.visibleSlides || []).forEach((e) => {
              s.push(e);
            });
          else
            for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
              let e = t.activeIndex + i;
              if (e > t.slides.length && !a) break;
              s.push(l(e));
            }
        else s.push(l(t.activeIndex));
        for (i = 0; i < s.length; i += 1)
          if (void 0 !== s[i]) {
            let e = s[i].offsetHeight;
            r = e > r ? e : r;
          }
        (!r && 0 !== r) || (t.wrapperEl.style.height = r + "px");
      },
      updateSlidesOffset: function () {
        var t = this,
          s = t.slides,
          a = t.isElement
            ? t.isHorizontal()
              ? t.wrapperEl.offsetLeft
              : t.wrapperEl.offsetTop
            : 0;
        for (let e = 0; e < s.length; e += 1)
          s[e].swiperSlideOffset =
            (t.isHorizontal() ? s[e].offsetLeft : s[e].offsetTop) -
            a -
            t.cssOverflowAdjustment();
      },
      updateSlidesProgress: function (e) {
        void 0 === e && (e = (this && this.translate) || 0);
        var i = this,
          r = i.params,
          { slides: l, rtlTranslate: n, snapGrid: o } = i;
        if (0 !== l.length) {
          void 0 === l[0].swiperSlideOffset && i.updateSlidesOffset();
          let s = n ? e : -e,
            a =
              ((i.visibleSlidesIndexes = []),
              (i.visibleSlides = []),
              r.spaceBetween);
          "string" == typeof a && 0 <= a.indexOf("%")
            ? (a = (parseFloat(a.replace("%", "")) / 100) * i.size)
            : "string" == typeof a && (a = parseFloat(a));
          for (let t = 0; t < l.length; t += 1) {
            var d = l[t];
            let e = d.swiperSlideOffset;
            r.cssMode && r.centeredSlides && (e -= l[0].swiperSlideOffset);
            var p =
                (s + (r.centeredSlides ? i.minTranslate() : 0) - e) /
                (d.swiperSlideSize + a),
              c =
                (s - o[0] + (r.centeredSlides ? i.minTranslate() : 0) - e) /
                (d.swiperSlideSize + a),
              u = -(s - e),
              m = u + i.slidesSizesGrid[t],
              h = 0 <= u && u <= i.size - i.slidesSizesGrid[t],
              u =
                (0 <= u && u < i.size - 1) ||
                (1 < m && m <= i.size) ||
                (u <= 0 && m >= i.size);
            u && (i.visibleSlides.push(d), i.visibleSlidesIndexes.push(t)),
              H(d, u, r.slideVisibleClass),
              H(d, h, r.slideFullyVisibleClass),
              (d.progress = n ? -p : p),
              (d.originalProgress = n ? -c : c);
          }
        }
      },
      updateProgress: function (l) {
        var n = this;
        if (void 0 === l) {
          let e = n.rtlTranslate ? -1 : 1;
          l = (n && n.translate && n.translate * e) || 0;
        }
        let e = n.params,
          s = n.maxTranslate() - n.minTranslate(),
          { progress: a, isBeginning: i, isEnd: r, progressLoop: o } = n,
          t = i,
          d = r;
        if (0 === s) (a = 0), (i = !0), (r = !0);
        else {
          a = (l - n.minTranslate()) / s;
          let e = Math.abs(l - n.minTranslate()) < 1,
            t = Math.abs(l - n.maxTranslate()) < 1;
          (i = e || a <= 0), (r = t || 1 <= a), e && (a = 0), t && (a = 1);
        }
        if (e.loop) {
          let e = n.getSlideIndexByData(0),
            t = n.getSlideIndexByData(n.slides.length - 1),
            s = n.slidesGrid[e],
            a = n.slidesGrid[t],
            i = n.slidesGrid[n.slidesGrid.length - 1],
            r = Math.abs(l);
          1 < (o = r >= s ? (r - s) / i : (r + i - a) / i) && --o;
        }
        Object.assign(n, {
          progress: a,
          progressLoop: o,
          isBeginning: i,
          isEnd: r,
        }),
          (e.watchSlidesProgress || (e.centeredSlides && e.autoHeight)) &&
            n.updateSlidesProgress(l),
          i && !t && n.emit("reachBeginning toEdge"),
          r && !d && n.emit("reachEnd toEdge"),
          ((t && !i) || (d && !r)) && n.emit("fromEdge"),
          n.emit("progress", a);
      },
      updateSlidesClasses: function () {
        let t = this,
          { slides: e, params: s, slidesEl: a, activeIndex: i } = t,
          r = t.virtual && s.virtual.enabled,
          l = t.grid && s.grid && 1 < s.grid.rows,
          n = (e) => A(a, `.${s.slideClass}${e}, swiper-slide` + e)[0],
          o,
          d,
          p;
        if (r)
          if (s.loop) {
            let e = i - t.virtual.slidesBefore;
            (e = e < 0 ? t.virtual.slides.length + e : e) >=
              t.virtual.slides.length && (e -= t.virtual.slides.length),
              (o = n(`[data-swiper-slide-index="${e}"]`));
          } else o = n(`[data-swiper-slide-index="${i}"]`);
        else
          l
            ? ((o = e.filter((e) => e.column === i)[0]),
              (p = e.filter((e) => e.column === i + 1)[0]),
              (d = e.filter((e) => e.column === i - 1)[0]))
            : (o = e[i]);
        o &&
          !l &&
          ((p = ((e, t) => {
            for (var s = []; e.nextElementSibling; ) {
              var a = e.nextElementSibling;
              (t && !a.matches(t)) || s.push(a), (e = a);
            }
            return s;
          })(o, `.${s.slideClass}, swiper-slide`)[0]),
          s.loop && !p && (p = e[0]),
          (d = ((e, t) => {
            for (var s = []; e.previousElementSibling; ) {
              var a = e.previousElementSibling;
              (t && !a.matches(t)) || s.push(a), (e = a);
            }
            return s;
          })(o, `.${s.slideClass}, swiper-slide`)[0]),
          s.loop) &&
          0 === !d &&
          (d = e[e.length - 1]),
          e.forEach((e) => {
            c(e, e === o, s.slideActiveClass),
              c(e, e === p, s.slideNextClass),
              c(e, e === d, s.slidePrevClass);
          }),
          t.emitSlidesClasses();
      },
      updateActiveIndex: function (e) {
        let a = this,
          t = a.rtlTranslate ? a.translate : -a.translate,
          {
            snapGrid: s,
            params: i,
            activeIndex: r,
            realIndex: l,
            snapIndex: n,
          } = a,
          o,
          d = e;
        e = (e) => {
          let t = e - a.virtual.slidesBefore;
          return (
            (t = t < 0 ? a.virtual.slides.length + t : t) >=
              a.virtual.slides.length && (t -= a.virtual.slides.length),
            t
          );
        };
        if (
          (void 0 === d &&
            (d = ((e) => {
              var { slidesGrid: t, params: s } = e,
                a = e.rtlTranslate ? e.translate : -e.translate;
              let i;
              for (let e = 0; e < t.length; e += 1)
                void 0 !== t[e + 1]
                  ? a >= t[e] && a < t[e + 1] - (t[e + 1] - t[e]) / 2
                    ? (i = e)
                    : a >= t[e] && a < t[e + 1] && (i = e + 1)
                  : a >= t[e] && (i = e);
              return (i =
                s.normalizeSlideIndex && (i < 0 || void 0 === i) ? 0 : i);
            })(a)),
          0 <= s.indexOf(t))
        )
          o = s.indexOf(t);
        else {
          let e = Math.min(i.slidesPerGroupSkip, d);
          o = e + Math.floor((d - e) / i.slidesPerGroup);
        }
        if ((o >= s.length && (o = s.length - 1), d !== r || a.params.loop))
          if (d === r && a.params.loop && a.virtual && a.params.virtual.enabled)
            a.realIndex = e(d);
          else {
            var p = a.grid && i.grid && 1 < i.grid.rows;
            let s;
            if (a.virtual && i.virtual.enabled && i.loop) s = e(d);
            else if (p) {
              let e = a.slides.filter((e) => e.column === d)[0],
                t = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
              Number.isNaN(t) && (t = Math.max(a.slides.indexOf(e), 0)),
                (s = Math.floor(t / i.grid.rows));
            } else if (a.slides[d]) {
              let e = a.slides[d].getAttribute("data-swiper-slide-index");
              s = e ? parseInt(e, 10) : d;
            } else s = d;
            Object.assign(a, {
              previousSnapIndex: n,
              snapIndex: o,
              previousRealIndex: l,
              realIndex: s,
              previousIndex: r,
              activeIndex: d,
            }),
              a.initialized && m(a),
              a.emit("activeIndexChange"),
              a.emit("snapIndexChange"),
              (a.initialized || a.params.runCallbacksOnInit) &&
                (l !== s && a.emit("realIndexChange"), a.emit("slideChange"));
          }
        else o !== n && ((a.snapIndex = o), a.emit("snapIndexChange"));
      },
      updateClickedSlide: function (e, t) {
        let s = this,
          a = s.params,
          i = e.closest(`.${a.slideClass}, swiper-slide`);
        !i &&
          s.isElement &&
          t &&
          1 < t.length &&
          t.includes(e) &&
          [...t.slice(t.indexOf(e) + 1, t.length)].forEach((e) => {
            !i &&
              e.matches &&
              e.matches(`.${a.slideClass}, swiper-slide`) &&
              (i = e);
          });
        let r,
          l = !1;
        if (i)
          for (let e = 0; e < s.slides.length; e += 1)
            if (s.slides[e] === i) {
              (l = !0), (r = e);
              break;
            }
        i && l
          ? ((s.clickedSlide = i),
            s.virtual && s.params.virtual.enabled
              ? (s.clickedIndex = parseInt(
                  i.getAttribute("data-swiper-slide-index"),
                  10,
                ))
              : (s.clickedIndex = r),
            a.slideToClickedSlide &&
              void 0 !== s.clickedIndex &&
              s.clickedIndex !== s.activeIndex &&
              s.slideToClickedSlide())
          : ((s.clickedSlide = void 0), (s.clickedIndex = void 0));
      },
    },
    q = {
      getTranslate: function (e) {
        void 0 === e && (e = this.isHorizontal() ? "x" : "y");
        var { params: t, rtlTranslate: s, translate: a, wrapperEl: i } = this;
        if (t.virtualTranslate) return s ? -a : a;
        if (t.cssMode) return a;
        let r = _(i, e);
        return (r += this.cssOverflowAdjustment()), (r = s ? -r : r) || 0;
      },
      setTranslate: function (e, t) {
        var s = this,
          { rtlTranslate: a, params: i, wrapperEl: r, progress: l } = s;
        let n = 0,
          o = 0;
        s.isHorizontal() ? (n = a ? -e : e) : (o = e),
          i.roundLengths && ((n = Math.floor(n)), (o = Math.floor(o))),
          (s.previousTranslate = s.translate),
          (s.translate = s.isHorizontal() ? n : o),
          i.cssMode
            ? (r[s.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                s.isHorizontal() ? -n : -o)
            : i.virtualTranslate ||
              (s.isHorizontal()
                ? (n -= s.cssOverflowAdjustment())
                : (o -= s.cssOverflowAdjustment()),
              (r.style.transform = `translate3d(${n}px, ${o}px, 0px)`));
        a = s.maxTranslate() - s.minTranslate();
        (0 == a ? 0 : (e - s.minTranslate()) / a) !== l && s.updateProgress(e),
          s.emit("setTranslate", s.translate, t);
      },
      minTranslate: function () {
        return -this.snapGrid[0];
      },
      maxTranslate: function () {
        return -this.snapGrid[this.snapGrid.length - 1];
      },
      translateTo: function (e, t, s, a, i) {
        void 0 === e && (e = 0),
          void 0 === t && (t = this.params.speed),
          void 0 === s && (s = !0),
          void 0 === a && (a = !0);
        let r = this,
          { params: l, wrapperEl: n } = r;
        if (r.animating && l.preventInteractionOnTransition) return !1;
        var o = r.minTranslate(),
          d = r.maxTranslate(),
          o = a && o < e ? o : a && e < d ? d : e;
        if ((r.updateProgress(o), l.cssMode)) {
          let e = r.isHorizontal();
          if (0 === t) n[e ? "scrollLeft" : "scrollTop"] = -o;
          else {
            if (!r.support.smoothScroll)
              return (
                T({ swiper: r, targetPosition: -o, side: e ? "left" : "top" }),
                !0
              );
            n.scrollTo({ [e ? "left" : "top"]: -o, behavior: "smooth" });
          }
        } else
          0 === t
            ? (r.setTransition(0),
              r.setTranslate(o),
              s &&
                (r.emit("beforeTransitionStart", t, i),
                r.emit("transitionEnd")))
            : (r.setTransition(t),
              r.setTranslate(o),
              s &&
                (r.emit("beforeTransitionStart", t, i),
                r.emit("transitionStart")),
              r.animating ||
                ((r.animating = !0),
                r.onTranslateToWrapperTransitionEnd ||
                  (r.onTranslateToWrapperTransitionEnd = function (e) {
                    r &&
                      !r.destroyed &&
                      e.target === this &&
                      (r.wrapperEl.removeEventListener(
                        "transitionend",
                        r.onTranslateToWrapperTransitionEnd,
                      ),
                      (r.onTranslateToWrapperTransitionEnd = null),
                      delete r.onTranslateToWrapperTransitionEnd,
                      (r.animating = !1),
                      s) &&
                      r.emit("transitionEnd");
                  }),
                r.wrapperEl.addEventListener(
                  "transitionend",
                  r.onTranslateToWrapperTransitionEnd,
                )));
        return !0;
      },
    };
  function R(e) {
    var { swiper: e, runCallbacks: t, direction: s, step: a } = e,
      { activeIndex: i, previousIndex: r } = e;
    let l = s;
    if (
      ((l = l || (r < i ? "next" : i < r ? "prev" : "reset")),
      e.emit("transition" + a),
      t && i !== r)
    ) {
      if ("reset" === l) return e.emit("slideResetTransition" + a);
      e.emit("slideChangeTransition" + a),
        "next" === l
          ? e.emit("slideNextTransition" + a)
          : e.emit("slidePrevTransition" + a);
    }
  }
  function $(e, t, s) {
    var a = g(),
      e = e.params,
      i = e.edgeSwipeDetection,
      e = e.edgeSwipeThreshold;
    return (
      !i ||
      !(s <= e || s >= a.innerWidth - e) ||
      ("prevent" === i && (t.preventDefault(), !0))
    );
  }
  function X() {
    let e = this,
      { params: t, el: s } = e;
    var a, i, r, l, n;
    (s && 0 === s.offsetWidth) ||
      (t.breakpoints && e.setBreakpoint(),
      ({ allowSlideNext: a, allowSlidePrev: i, snapGrid: r } = e),
      (l = e.virtual && e.params.virtual.enabled),
      (e.allowSlideNext = !0),
      (e.allowSlidePrev = !0),
      e.updateSize(),
      e.updateSlides(),
      e.updateSlidesClasses(),
      (n = l && t.loop),
      !("auto" === t.slidesPerView || 1 < t.slidesPerView) ||
      !e.isEnd ||
      e.isBeginning ||
      e.params.centeredSlides ||
      n
        ? e.params.loop && !l
          ? e.slideToLoop(e.realIndex, 0, !1, !0)
          : e.slideTo(e.activeIndex, 0, !1, !0)
        : e.slideTo(e.slides.length - 1, 0, !1, !0),
      e.autoplay &&
        e.autoplay.running &&
        e.autoplay.paused &&
        (clearTimeout(e.autoplay.resizeTimeout),
        (e.autoplay.resizeTimeout = setTimeout(() => {
          e.autoplay &&
            e.autoplay.running &&
            e.autoplay.paused &&
            e.autoplay.resume();
        }, 500))),
      (e.allowSlidePrev = i),
      (e.allowSlideNext = a),
      e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow());
  }
  let Y = (e, t) => {
      var s = I(),
        { params: a, el: i, wrapperEl: r, device: l } = e,
        n = !!a.nested,
        o = "on" === t ? "addEventListener" : "removeEventListener";
      i &&
        "string" != typeof i &&
        (s[o]("touchstart", e.onDocumentTouchStart, {
          passive: !1,
          capture: n,
        }),
        i[o]("touchstart", e.onTouchStart, { passive: !1 }),
        i[o]("pointerdown", e.onTouchStart, { passive: !1 }),
        s[o]("touchmove", e.onTouchMove, { passive: !1, capture: n }),
        s[o]("pointermove", e.onTouchMove, { passive: !1, capture: n }),
        s[o]("touchend", e.onTouchEnd, { passive: !0 }),
        s[o]("pointerup", e.onTouchEnd, { passive: !0 }),
        s[o]("pointercancel", e.onTouchEnd, { passive: !0 }),
        s[o]("touchcancel", e.onTouchEnd, { passive: !0 }),
        s[o]("pointerout", e.onTouchEnd, { passive: !0 }),
        s[o]("pointerleave", e.onTouchEnd, { passive: !0 }),
        s[o]("contextmenu", e.onTouchEnd, { passive: !0 }),
        (a.preventClicks || a.preventClicksPropagation) &&
          i[o]("click", e.onClick, !0),
        a.cssMode && r[o]("scroll", e.onScroll),
        a.updateOnWindowResize
          ? e[t](
              l.ios || l.android
                ? "resize orientationchange observerUpdate"
                : "resize observerUpdate",
              X,
              !0,
            )
          : e[t]("observerUpdate", X, !0),
        i[o]("load", e.onLoad, { capture: !0 }));
    },
    W = (e, t) => e.grid && t.grid && 1 < t.grid.rows;
  var U = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  let h = {
      eventsEmitter: V,
      update: j,
      translate: q,
      transition: {
        setTransition: function (e, t) {
          this.params.cssMode ||
            ((this.wrapperEl.style.transitionDuration = e + "ms"),
            (this.wrapperEl.style.transitionDelay = 0 === e ? "0ms" : "")),
            this.emit("setTransition", e, t);
        },
        transitionStart: function (e, t) {
          void 0 === e && (e = !0);
          var s = this.params;
          s.cssMode ||
            (s.autoHeight && this.updateAutoHeight(),
            R({ swiper: this, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e, t) {
          void 0 === e && (e = !0);
          var s = this.params;
          (this.animating = !1),
            s.cssMode ||
              (this.setTransition(0),
              R({ swiper: this, runCallbacks: e, direction: t, step: "End" }));
        },
      },
      slide: {
        slideTo: function (e, a, t, s, i) {
          void 0 === t && (t = !0),
            "string" == typeof (e = void 0 === e ? 0 : e) &&
              (e = parseInt(e, 10));
          let r = this,
            l = e,
            {
              params: n,
              snapGrid: o,
              slidesGrid: d,
              previousIndex: p,
              activeIndex: c,
              rtlTranslate: u,
              wrapperEl: m,
              enabled: h,
            } = (l < 0 && (l = 0), r);
          if (
            (!h && !s && !i) ||
            r.destroyed ||
            (r.animating && n.preventInteractionOnTransition)
          )
            return !1;
          void 0 === a && (a = r.params.speed);
          e = Math.min(r.params.slidesPerGroupSkip, l);
          let f = e + Math.floor((l - e) / r.params.slidesPerGroup);
          var v = -o[(f = f >= o.length ? o.length - 1 : f)];
          if (n.normalizeSlideIndex)
            for (let a = 0; a < d.length; a += 1) {
              let e = -Math.floor(100 * v),
                t = Math.floor(100 * d[a]),
                s = Math.floor(100 * d[a + 1]);
              void 0 !== d[a + 1]
                ? e >= t && e < s - (s - t) / 2
                  ? (l = a)
                  : e >= t && e < s && (l = a + 1)
                : e >= t && (l = a);
            }
          if (r.initialized && l !== c) {
            if (
              !r.allowSlideNext &&
              (u
                ? v > r.translate && v > r.minTranslate()
                : v < r.translate && v < r.minTranslate())
            )
              return !1;
            if (
              !r.allowSlidePrev &&
              v > r.translate &&
              v > r.maxTranslate() &&
              (c || 0) !== l
            )
              return !1;
          }
          let g;
          if (
            (l !== (p || 0) && t && r.emit("beforeSlideChangeStart"),
            r.updateProgress(v),
            (g = l > c ? "next" : l < c ? "prev" : "reset"),
            (u && -v === r.translate) || (!u && v === r.translate))
          )
            return (
              r.updateActiveIndex(l),
              n.autoHeight && r.updateAutoHeight(),
              r.updateSlidesClasses(),
              "slide" !== n.effect && r.setTranslate(v),
              "reset" != g && (r.transitionStart(t, g), r.transitionEnd(t, g)),
              !1
            );
          if (n.cssMode) {
            let t = r.isHorizontal(),
              s = u ? v : -v;
            if (0 === a) {
              let e = r.virtual && r.params.virtual.enabled;
              e &&
                ((r.wrapperEl.style.scrollSnapType = "none"),
                (r._immediateVirtual = !0)),
                e && !r._cssModeVirtualInitialSet && 0 < r.params.initialSlide
                  ? ((r._cssModeVirtualInitialSet = !0),
                    requestAnimationFrame(() => {
                      m[t ? "scrollLeft" : "scrollTop"] = s;
                    }))
                  : (m[t ? "scrollLeft" : "scrollTop"] = s),
                e &&
                  requestAnimationFrame(() => {
                    (r.wrapperEl.style.scrollSnapType = ""),
                      (r._immediateVirtual = !1);
                  });
            } else {
              if (!r.support.smoothScroll)
                return (
                  T({ swiper: r, targetPosition: s, side: t ? "left" : "top" }),
                  !0
                );
              m.scrollTo({ [t ? "left" : "top"]: s, behavior: "smooth" });
            }
          } else
            r.setTransition(a),
              r.setTranslate(v),
              r.updateActiveIndex(l),
              r.updateSlidesClasses(),
              r.emit("beforeTransitionStart", a, s),
              r.transitionStart(t, g),
              0 === a
                ? r.transitionEnd(t, g)
                : r.animating ||
                  ((r.animating = !0),
                  r.onSlideToWrapperTransitionEnd ||
                    (r.onSlideToWrapperTransitionEnd = function (e) {
                      r &&
                        !r.destroyed &&
                        e.target === this &&
                        (r.wrapperEl.removeEventListener(
                          "transitionend",
                          r.onSlideToWrapperTransitionEnd,
                        ),
                        (r.onSlideToWrapperTransitionEnd = null),
                        delete r.onSlideToWrapperTransitionEnd,
                        r.transitionEnd(t, g));
                    }),
                  r.wrapperEl.addEventListener(
                    "transitionend",
                    r.onSlideToWrapperTransitionEnd,
                  ));
          return !0;
        },
        slideToLoop: function (e, t, s, l) {
          void 0 === s && (s = !0),
            "string" == typeof (e = void 0 === e ? 0 : e) &&
              (e = parseInt(e, 10));
          let n = this;
          if (!n.destroyed) {
            void 0 === t && (t = n.params.speed);
            var o = n.grid && n.params.grid && 1 < n.params.grid.rows;
            let r = e;
            if (n.params.loop)
              if (n.virtual && n.params.virtual.enabled)
                r += n.virtual.slidesBefore;
              else {
                let s;
                if (o) {
                  let t = r * n.params.grid.rows;
                  s = n.slides.filter(
                    (e) => +e.getAttribute("data-swiper-slide-index") == t,
                  )[0].column;
                } else s = n.getSlideIndexByData(r);
                let t = o
                    ? Math.ceil(n.slides.length / n.params.grid.rows)
                    : n.slides.length,
                  a = n.params.centeredSlides,
                  e = n.params.slidesPerView,
                  i =
                    ("auto" === e
                      ? (e = n.slidesPerViewDynamic())
                      : ((e = Math.ceil(
                          parseFloat(n.params.slidesPerView, 10),
                        )),
                        a && e % 2 == 0 && (e += 1)),
                    t - s < e);
                if (
                  (a && (i = i || s < Math.ceil(e / 2)),
                  (i =
                    l && a && "auto" !== n.params.slidesPerView && !o ? !1 : i))
                ) {
                  let e = a
                    ? s < n.activeIndex
                      ? "prev"
                      : "next"
                    : s - n.activeIndex - 1 < n.params.slidesPerView
                      ? "next"
                      : "prev";
                  n.loopFix({
                    direction: e,
                    slideTo: !0,
                    activeSlideIndex: "next" == e ? s + 1 : s - t + 1,
                    slideRealIndex: "next" == e ? n.realIndex : void 0,
                  });
                }
                if (o) {
                  let t = r * n.params.grid.rows;
                  r = n.slides.filter(
                    (e) => +e.getAttribute("data-swiper-slide-index") == t,
                  )[0].column;
                } else r = n.getSlideIndexByData(r);
              }
            return (
              requestAnimationFrame(() => {
                n.slideTo(r, t, s, l);
              }),
              n
            );
          }
        },
        slideNext: function (e, t, s) {
          void 0 === t && (t = !0);
          let a = this,
            { enabled: i, params: r, animating: l } = a;
          if (!i || a.destroyed) return a;
          void 0 === e && (e = a.params.speed);
          let n = r.slidesPerGroup,
            o =
              ("auto" === r.slidesPerView &&
                1 === r.slidesPerGroup &&
                r.slidesPerGroupAuto &&
                (n = Math.max(a.slidesPerViewDynamic("current", !0), 1)),
              a.activeIndex < r.slidesPerGroupSkip ? 1 : n),
            d = a.virtual && r.virtual.enabled;
          if (r.loop) {
            if (l && !d && r.loopPreventsSliding) return !1;
            if (
              (a.loopFix({ direction: "next" }),
              (a._clientLeft = a.wrapperEl.clientLeft),
              a.activeIndex === a.slides.length - 1 && r.cssMode)
            )
              return (
                requestAnimationFrame(() => {
                  a.slideTo(a.activeIndex + o, e, t, s);
                }),
                !0
              );
          }
          return r.rewind && a.isEnd
            ? a.slideTo(0, e, t, s)
            : a.slideTo(a.activeIndex + o, e, t, s);
        },
        slidePrev: function (t, s, a) {
          void 0 === s && (s = !0);
          let i = this,
            {
              params: e,
              snapGrid: r,
              slidesGrid: l,
              rtlTranslate: n,
              enabled: o,
              animating: d,
            } = i;
          if (!o || i.destroyed) return i;
          void 0 === t && (t = i.params.speed);
          var p = i.virtual && e.virtual.enabled;
          if (e.loop) {
            if (d && !p && e.loopPreventsSliding) return !1;
            i.loopFix({ direction: "prev" }),
              (i._clientLeft = i.wrapperEl.clientLeft);
          }
          function c(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          let u = c(n ? i.translate : -i.translate),
            m = r.map((e) => c(e)),
            h = r[m.indexOf(u) - 1];
          if (void 0 === h && e.cssMode) {
            let s;
            r.forEach((e, t) => {
              u >= e && (s = t);
            }),
              void 0 !== s && (h = r[0 < s ? s - 1 : s]);
          }
          let f = 0;
          if (
            (void 0 !== h &&
              ((f = l.indexOf(h)) < 0 && (f = i.activeIndex - 1),
              "auto" === e.slidesPerView) &&
              1 === e.slidesPerGroup &&
              e.slidesPerGroupAuto &&
              ((f = f - i.slidesPerViewDynamic("previous", !0) + 1),
              (f = Math.max(f, 0))),
            e.rewind && i.isBeginning)
          ) {
            let e =
              i.params.virtual && i.params.virtual.enabled && i.virtual
                ? i.virtual.slides.length - 1
                : i.slides.length - 1;
            return i.slideTo(e, t, s, a);
          }
          return e.loop && 0 === i.activeIndex && e.cssMode
            ? (requestAnimationFrame(() => {
                i.slideTo(f, t, s, a);
              }),
              !0)
            : i.slideTo(f, t, s, a);
        },
        slideReset: function (e, t, s) {
          void 0 === t && (t = !0);
          if (!this.destroyed)
            return (
              void 0 === e && (e = this.params.speed),
              this.slideTo(this.activeIndex, e, t, s)
            );
        },
        slideToClosest: function (e, s, a, i) {
          void 0 === s && (s = !0), void 0 === i && (i = 0.5);
          var r = this;
          if (!r.destroyed) {
            void 0 === e && (e = r.params.speed);
            let t = r.activeIndex;
            var l = Math.min(r.params.slidesPerGroupSkip, t),
              l = l + Math.floor((t - l) / r.params.slidesPerGroup),
              n = r.rtlTranslate ? r.translate : -r.translate;
            if (n >= r.snapGrid[l]) {
              let e = r.snapGrid[l];
              n - e > (r.snapGrid[l + 1] - e) * i &&
                (t += r.params.slidesPerGroup);
            } else {
              let e = r.snapGrid[l - 1];
              n - e <= (r.snapGrid[l] - e) * i &&
                (t -= r.params.slidesPerGroup);
            }
            return (
              (t = Math.max(t, 0)),
              (t = Math.min(t, r.slidesGrid.length - 1)),
              r.slideTo(t, e, s, a)
            );
          }
        },
        slideToClickedSlide: function () {
          let s = this;
          if (!s.destroyed) {
            var { params: a, slidesEl: i } = s,
              r =
                "auto" === a.slidesPerView
                  ? s.slidesPerViewDynamic()
                  : a.slidesPerView;
            let e,
              t = s.clickedIndex;
            var l = s.isElement ? "swiper-slide" : "." + a.slideClass;
            a.loop
              ? s.animating ||
                ((e = parseInt(
                  s.clickedSlide.getAttribute("data-swiper-slide-index"),
                  10,
                )),
                a.centeredSlides
                  ? t < s.loopedSlides - r / 2 ||
                    t > s.slides.length - s.loopedSlides + r / 2
                    ? (s.loopFix(),
                      (t = s.getSlideIndex(
                        A(i, l + `[data-swiper-slide-index="${e}"]`)[0],
                      )),
                      w(() => {
                        s.slideTo(t);
                      }))
                    : s.slideTo(t)
                  : t > s.slides.length - r
                    ? (s.loopFix(),
                      (t = s.getSlideIndex(
                        A(i, l + `[data-swiper-slide-index="${e}"]`)[0],
                      )),
                      w(() => {
                        s.slideTo(t);
                      }))
                    : s.slideTo(t))
              : s.slideTo(t);
          }
        },
      },
      loop: {
        loopCreate: function (e) {
          let s = this,
            { params: a, slidesEl: t } = s;
          var i, r, l, n, o;
          !a.loop ||
            (s.virtual && s.params.virtual.enabled) ||
            ((i = () => {
              A(t, `.${a.slideClass}, swiper-slide`).forEach((e, t) => {
                e.setAttribute("data-swiper-slide-index", t);
              });
            }),
            (n = s.grid && a.grid && 1 < a.grid.rows),
            (r = a.slidesPerGroup * (n ? a.grid.rows : 1)),
            (l = s.slides.length % r != 0),
            (n = n && s.slides.length % a.grid.rows != 0),
            (o = (t) => {
              for (let e = 0; e < t; e += 1) {
                let e = s.isElement
                  ? p("swiper-slide", [a.slideBlankClass])
                  : p("div", [a.slideClass, a.slideBlankClass]);
                s.slidesEl.append(e);
              }
            }),
            l
              ? a.loopAddBlankSlides
                ? (o(r - (s.slides.length % r)),
                  s.recalcSlides(),
                  s.updateSlides())
                : P(
                    "Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)",
                  )
              : n &&
                (a.loopAddBlankSlides
                  ? (o(a.grid.rows - (s.slides.length % a.grid.rows)),
                    s.recalcSlides(),
                    s.updateSlides())
                  : P(
                      "Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)",
                    )),
            i(),
            s.loopFix({
              slideRealIndex: e,
              direction: a.centeredSlides ? void 0 : "next",
            }));
        },
        loopFix: function (m) {
          let {
              slideRealIndex: h,
              slideTo: f = !0,
              direction: v,
              setTranslate: g,
              activeSlideIndex: w,
              byController: b,
              byMousewheel: y,
            } = void 0 === m ? {} : m,
            T = this;
          if (T.params.loop) {
            T.emit("beforeLoopFix");
            let {
                slides: o,
                allowSlidePrev: t,
                allowSlideNext: d,
                slidesEl: p,
                params: c,
              } = T,
              u = c.centeredSlides;
            if (
              ((T.allowSlidePrev = !0),
              (T.allowSlideNext = !0),
              T.virtual && c.virtual.enabled)
            )
              f &&
                (c.centeredSlides || 0 !== T.snapIndex
                  ? c.centeredSlides && T.snapIndex < c.slidesPerView
                    ? T.slideTo(
                        T.virtual.slides.length + T.snapIndex,
                        0,
                        !1,
                        !0,
                      )
                    : T.snapIndex === T.snapGrid.length - 1 &&
                      T.slideTo(T.virtual.slidesBefore, 0, !1, !0)
                  : T.slideTo(T.virtual.slides.length, 0, !1, !0)),
                (T.allowSlidePrev = t),
                (T.allowSlideNext = d);
            else {
              let e = c.slidesPerView;
              "auto" === e
                ? (e = T.slidesPerViewDynamic())
                : ((e = Math.ceil(parseFloat(c.slidesPerView, 10))),
                  u && e % 2 == 0 && (e += 1));
              m = c.slidesPerGroupAuto ? e : c.slidesPerGroup;
              let s = m;
              s % m != 0 && (s += m - (s % m)),
                (s += c.loopAdditionalSlides),
                (T.loopedSlides = s);
              var x = T.grid && c.grid && 1 < c.grid.rows;
              o.length < e + s
                ? P(
                    "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters",
                  )
                : x &&
                  "row" === c.grid.fill &&
                  P(
                    "Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`",
                  );
              let a = [],
                i = [],
                r = T.activeIndex;
              void 0 === w
                ? (w = T.getSlideIndex(
                    o.filter((e) =>
                      e.classList.contains(c.slideActiveClass),
                    )[0],
                  ))
                : (r = w);
              var S = "next" === v || !v,
                E = "prev" === v || !v;
              let l = 0,
                n = 0;
              var M = x ? Math.ceil(o.length / c.grid.rows) : o.length,
                C =
                  (x ? o[w].column : w) +
                  (u && void 0 === g ? -e / 2 + 0.5 : 0);
              if (C < s) {
                l = Math.max(s - C, m);
                for (let t = 0; t < s - C; t += 1) {
                  let e = t - Math.floor(t / M) * M;
                  if (x) {
                    let t = M - e - 1;
                    for (let e = o.length - 1; 0 <= e; --e)
                      o[e].column === t && a.push(e);
                  } else a.push(M - e - 1);
                }
              } else if (C + e > M - s) {
                n = Math.max(C - (M - 2 * s), m);
                for (let e = 0; e < n; e += 1) {
                  let s = e - Math.floor(e / M) * M;
                  x
                    ? o.forEach((e, t) => {
                        e.column === s && i.push(t);
                      })
                    : i.push(s);
                }
              }
              if (
                ((T.__preventObserver__ = !0),
                requestAnimationFrame(() => {
                  T.__preventObserver__ = !1;
                }),
                E &&
                  a.forEach((e) => {
                    (o[e].swiperLoopMoveDOM = !0),
                      p.prepend(o[e]),
                      (o[e].swiperLoopMoveDOM = !1);
                  }),
                S &&
                  i.forEach((e) => {
                    (o[e].swiperLoopMoveDOM = !0),
                      p.append(o[e]),
                      (o[e].swiperLoopMoveDOM = !1);
                  }),
                T.recalcSlides(),
                "auto" === c.slidesPerView
                  ? T.updateSlides()
                  : x &&
                    ((0 < a.length && E) || (0 < i.length && S)) &&
                    T.slides.forEach((e, t) => {
                      T.grid.updateSlide(t, e, T.slides);
                    }),
                c.watchSlidesProgress && T.updateSlidesOffset(),
                f)
              )
                if (0 < a.length && E) {
                  if (void 0 === h) {
                    let e = T.slidesGrid[r],
                      t = T.slidesGrid[r + l] - e;
                    y
                      ? T.setTranslate(T.translate - t)
                      : (T.slideTo(r + Math.ceil(l), 0, !1, !0),
                        g &&
                          ((T.touchEventsData.startTranslate =
                            T.touchEventsData.startTranslate - t),
                          (T.touchEventsData.currentTranslate =
                            T.touchEventsData.currentTranslate - t)));
                  } else if (g) {
                    let e = x ? a.length / c.grid.rows : a.length;
                    T.slideTo(T.activeIndex + e, 0, !1, !0),
                      (T.touchEventsData.currentTranslate = T.translate);
                  }
                } else if (0 < i.length && S)
                  if (void 0 === h) {
                    let e = T.slidesGrid[r],
                      t = T.slidesGrid[r - n] - e;
                    y
                      ? T.setTranslate(T.translate - t)
                      : (T.slideTo(r - n, 0, !1, !0),
                        g &&
                          ((T.touchEventsData.startTranslate =
                            T.touchEventsData.startTranslate - t),
                          (T.touchEventsData.currentTranslate =
                            T.touchEventsData.currentTranslate - t)));
                  } else {
                    let e = x ? i.length / c.grid.rows : i.length;
                    T.slideTo(T.activeIndex - e, 0, !1, !0);
                  }
              if (
                ((T.allowSlidePrev = t),
                (T.allowSlideNext = d),
                T.controller && T.controller.control && !b)
              ) {
                let t = {
                  slideRealIndex: h,
                  direction: v,
                  setTranslate: g,
                  activeSlideIndex: w,
                  byController: !0,
                };
                Array.isArray(T.controller.control)
                  ? T.controller.control.forEach((e) => {
                      !e.destroyed &&
                        e.params.loop &&
                        e.loopFix({
                          ...t,
                          slideTo:
                            e.params.slidesPerView === c.slidesPerView && f,
                        });
                    })
                  : T.controller.control instanceof T.constructor &&
                    T.controller.control.params.loop &&
                    T.controller.control.loopFix({
                      ...t,
                      slideTo:
                        T.controller.control.params.slidesPerView ===
                          c.slidesPerView && f,
                    });
              }
            }
            T.emit("loopFix");
          }
        },
        loopDestroy: function () {
          let e = this,
            { params: t, slidesEl: a } = e;
          if (!(!t.loop || (e.virtual && e.params.virtual.enabled))) {
            e.recalcSlides();
            let s = [];
            e.slides.forEach((e) => {
              var t =
                void 0 === e.swiperSlideIndex
                  ? +e.getAttribute("data-swiper-slide-index")
                  : e.swiperSlideIndex;
              s[t] = e;
            }),
              e.slides.forEach((e) => {
                e.removeAttribute("data-swiper-slide-index");
              }),
              s.forEach((e) => {
                a.append(e);
              }),
              e.recalcSlides(),
              e.slideTo(e.realIndex, 0);
          }
        },
      },
      grabCursor: {
        setGrabCursor: function (e) {
          let t = this;
          var s;
          !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode ||
            ((s =
              "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl),
            t.isElement && (t.__preventObserver__ = !0),
            (s.style.cursor = "move"),
            (s.style.cursor = e ? "grabbing" : "grab"),
            t.isElement &&
              requestAnimationFrame(() => {
                t.__preventObserver__ = !1;
              }));
        },
        unsetGrabCursor: function () {
          let e = this;
          (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e.isElement && (e.__preventObserver__ = !0),
            (e[
              "container" === e.params.touchEventsTarget ? "el" : "wrapperEl"
            ].style.cursor = ""),
            e.isElement &&
              requestAnimationFrame(() => {
                e.__preventObserver__ = !1;
              }));
        },
      },
      events: {
        attachEvents: function () {
          var e = this,
            t = e.params;
          (e.onTouchStart = function (s) {
            var a = this,
              i = I();
            let r = s;
            if (
              (r.originalEvent && (r = r.originalEvent),
              (s = a.touchEventsData),
              "pointerdown" === r.type)
            ) {
              if (null !== s.pointerId && s.pointerId !== r.pointerId) return;
              s.pointerId = r.pointerId;
            } else
              "touchstart" === r.type &&
                1 === r.targetTouches.length &&
                (s.touchId = r.targetTouches[0].identifier);
            if ("touchstart" === r.type) $(a, r, r.targetTouches[0].pageX);
            else {
              var { params: l, touches: n, enabled: o } = a;
              if (
                o &&
                (l.simulateTouch || "mouse" !== r.pointerType) &&
                (!a.animating || !l.preventInteractionOnTransition)
              ) {
                !a.animating && l.cssMode && l.loop && a.loopFix();
                let t = r.target;
                if (
                  ("wrapper" !== l.touchEventsTarget ||
                    a.wrapperEl.contains(t)) &&
                  !(
                    ("which" in r && 3 === r.which) ||
                    ("button" in r && 0 < r.button) ||
                    (s.isTouched && s.isMoved)
                  )
                ) {
                  var o = !!l.noSwipingClass && "" !== l.noSwipingClass,
                    d = r.composedPath ? r.composedPath() : r.path,
                    o =
                      (o && r.target && r.target.shadowRoot && d && (t = d[0]),
                      l.noSwipingSelector || "." + l.noSwipingClass),
                    d = !(!r.target || !r.target.shadowRoot);
                  if (
                    l.noSwiping &&
                    (d
                      ? (function (a, e) {
                          return (function e(t) {
                            var s;
                            return t &&
                              t !== I() &&
                              t !== g() &&
                              ((s = (t = t.assignedSlot
                                ? t.assignedSlot
                                : t).closest(a)) ||
                                t.getRootNode)
                              ? s || e(t.getRootNode().host)
                              : null;
                          })((e = void 0 === t ? this : e));
                        })(o, t)
                      : t.closest(o))
                  )
                    a.allowClick = !0;
                  else if (!l.swipeHandler || t.closest(l.swipeHandler)) {
                    (n.currentX = r.pageX), (n.currentY = r.pageY);
                    (d = n.currentX), (o = n.currentY);
                    if ($(a, r, d)) {
                      Object.assign(s, {
                        isTouched: !0,
                        isMoved: !1,
                        allowTouchCallbacks: !0,
                        isScrolling: void 0,
                        startMoving: void 0,
                      }),
                        (n.startX = d),
                        (n.startY = o),
                        (s.touchStartTime = b()),
                        (a.allowClick = !0),
                        a.updateSize(),
                        (a.swipeDirection = void 0),
                        0 < l.threshold && (s.allowThresholdMove = !1);
                      let e = !0;
                      t.matches(s.focusableElements) &&
                        ((e = !1), "SELECT" === t.nodeName) &&
                        (s.isTouched = !1),
                        i.activeElement &&
                          i.activeElement.matches(s.focusableElements) &&
                          i.activeElement !== t &&
                          i.activeElement.blur();
                      d = e && a.allowTouchMove && l.touchStartPreventDefault;
                      (!l.touchStartForcePreventDefault && !d) ||
                        t.isContentEditable ||
                        r.preventDefault(),
                        l.freeMode &&
                          l.freeMode.enabled &&
                          a.freeMode &&
                          a.animating &&
                          !l.cssMode &&
                          a.freeMode.onTouchStart(),
                        a.emit("touchStart", r);
                    }
                  }
                }
              }
            }
          }.bind(e)),
            (e.onTouchMove = function (t) {
              let s = I(),
                i = this,
                r = i.touchEventsData,
                { params: l, touches: n, rtlTranslate: o, enabled: e } = i;
              if (e && (l.simulateTouch || "mouse" !== t.pointerType)) {
                let e,
                  a = t;
                if (
                  "pointermove" ===
                  (a = a.originalEvent ? a.originalEvent : a).type
                ) {
                  if (null !== r.touchId) return;
                  if (a.pointerId !== r.pointerId) return;
                }
                if ("touchmove" === a.type) {
                  if (
                    !(e = [...a.changedTouches].filter(
                      (e) => e.identifier === r.touchId,
                    )[0]) ||
                    e.identifier !== r.touchId
                  )
                    return;
                } else e = a;
                if (r.isTouched) {
                  var t = e.pageX,
                    d = e.pageY;
                  if (a.preventedByNestedSwiper) (n.startX = t), (n.startY = d);
                  else if (i.allowTouchMove) {
                    if (l.touchReleaseOnEdges && !l.loop)
                      if (i.isVertical()) {
                        if (
                          (d < n.startY && i.translate <= i.maxTranslate()) ||
                          (d > n.startY && i.translate >= i.minTranslate())
                        )
                          return (r.isTouched = !1), void (r.isMoved = !1);
                      } else if (
                        (t < n.startX && i.translate <= i.maxTranslate()) ||
                        (t > n.startX && i.translate >= i.minTranslate())
                      )
                        return;
                    if (
                      s.activeElement &&
                      a.target === s.activeElement &&
                      a.target.matches(r.focusableElements)
                    )
                      (r.isMoved = !0), (i.allowClick = !1);
                    else {
                      r.allowTouchCallbacks && i.emit("touchMove", a),
                        (n.previousX = n.currentX),
                        (n.previousY = n.currentY),
                        (n.currentX = t),
                        (n.currentY = d);
                      var p = n.currentX - n.startX,
                        c = n.currentY - n.startY;
                      if (
                        !(
                          i.params.threshold &&
                          Math.sqrt(p ** 2 + c ** 2) < i.params.threshold
                        )
                      )
                        if (
                          (void 0 === r.isScrolling &&
                            ((i.isHorizontal() && n.currentY === n.startY) ||
                            (i.isVertical() && n.currentX === n.startX)
                              ? (r.isScrolling = !1)
                              : 25 <= p * p + c * c &&
                                ((u =
                                  (180 * Math.atan2(Math.abs(c), Math.abs(p))) /
                                  Math.PI),
                                (r.isScrolling = i.isHorizontal()
                                  ? u > l.touchAngle
                                  : 90 - u > l.touchAngle))),
                          r.isScrolling && i.emit("touchMoveOpposite", a),
                          void 0 !== r.startMoving ||
                            (n.currentX === n.startX &&
                              n.currentY === n.startY) ||
                            (r.startMoving = !0),
                          r.isScrolling ||
                            ("touchmove" === a.type &&
                              r.preventTouchMoveFromPointerMove))
                        )
                          r.isTouched = !1;
                        else if (r.startMoving) {
                          (i.allowClick = !1),
                            !l.cssMode && a.cancelable && a.preventDefault(),
                            l.touchMoveStopPropagation &&
                              !l.nested &&
                              a.stopPropagation();
                          let s = i.isHorizontal() ? p : c,
                            e = i.isHorizontal()
                              ? n.currentX - n.previousX
                              : n.currentY - n.previousY;
                          l.oneWayMovement &&
                            ((s = Math.abs(s) * (o ? 1 : -1)),
                            (e = Math.abs(e) * (o ? 1 : -1))),
                            (n.diff = s),
                            (s *= l.touchRatio),
                            o && ((s = -s), (e = -e));
                          var u = i.touchesDirection,
                            p =
                              ((i.swipeDirection = 0 < s ? "prev" : "next"),
                              (i.touchesDirection = 0 < e ? "prev" : "next"),
                              i.params.loop && !l.cssMode),
                            c =
                              ("next" === i.touchesDirection &&
                                i.allowSlideNext) ||
                              ("prev" === i.touchesDirection &&
                                i.allowSlidePrev);
                          if (!r.isMoved) {
                            if (
                              (p &&
                                c &&
                                i.loopFix({ direction: i.swipeDirection }),
                              (r.startTranslate = i.getTranslate()),
                              i.setTransition(0),
                              i.animating)
                            ) {
                              let e = new window.CustomEvent("transitionend", {
                                bubbles: !0,
                                cancelable: !0,
                                detail: { bySwiperTouchMove: !0 },
                              });
                              i.wrapperEl.dispatchEvent(e);
                            }
                            (r.allowMomentumBounce = !1),
                              !l.grabCursor ||
                                (!0 !== i.allowSlideNext &&
                                  !0 !== i.allowSlidePrev) ||
                                i.setGrabCursor(!0),
                              i.emit("sliderFirstMove", a);
                          }
                          if (
                            (new Date().getTime(),
                            r.isMoved &&
                              r.allowThresholdMove &&
                              u !== i.touchesDirection &&
                              p &&
                              c &&
                              1 <= Math.abs(s))
                          )
                            Object.assign(n, {
                              startX: t,
                              startY: d,
                              currentX: t,
                              currentY: d,
                              startTranslate: r.currentTranslate,
                            }),
                              (r.loopSwapReset = !0),
                              (r.startTranslate = r.currentTranslate);
                          else {
                            i.emit("sliderMove", a),
                              (r.isMoved = !0),
                              (r.currentTranslate = s + r.startTranslate);
                            let e = !0,
                              t = l.resistanceRatio;
                            if (
                              (l.touchReleaseOnEdges && (t = 0),
                              0 < s
                                ? (p &&
                                    c &&
                                    r.allowThresholdMove &&
                                    r.currentTranslate >
                                      (l.centeredSlides
                                        ? i.minTranslate() -
                                          i.slidesSizesGrid[i.activeIndex + 1]
                                        : i.minTranslate()) &&
                                    i.loopFix({
                                      direction: "prev",
                                      setTranslate: !0,
                                      activeSlideIndex: 0,
                                    }),
                                  r.currentTranslate > i.minTranslate() &&
                                    ((e = !1), l.resistance) &&
                                    (r.currentTranslate =
                                      i.minTranslate() -
                                      1 +
                                      (-i.minTranslate() +
                                        r.startTranslate +
                                        s) **
                                        t))
                                : s < 0 &&
                                  (p &&
                                    c &&
                                    r.allowThresholdMove &&
                                    r.currentTranslate <
                                      (l.centeredSlides
                                        ? i.maxTranslate() +
                                          i.slidesSizesGrid[
                                            i.slidesSizesGrid.length - 1
                                          ]
                                        : i.maxTranslate()) &&
                                    i.loopFix({
                                      direction: "next",
                                      setTranslate: !0,
                                      activeSlideIndex:
                                        i.slides.length -
                                        ("auto" === l.slidesPerView
                                          ? i.slidesPerViewDynamic()
                                          : Math.ceil(
                                              parseFloat(l.slidesPerView, 10),
                                            )),
                                    }),
                                  r.currentTranslate < i.maxTranslate()) &&
                                  ((e = !1), l.resistance) &&
                                  (r.currentTranslate =
                                    i.maxTranslate() +
                                    1 -
                                    (i.maxTranslate() - r.startTranslate - s) **
                                      t),
                              e && (a.preventedByNestedSwiper = !0),
                              !i.allowSlideNext &&
                                "next" === i.swipeDirection &&
                                r.currentTranslate < r.startTranslate &&
                                (r.currentTranslate = r.startTranslate),
                              !i.allowSlidePrev &&
                                "prev" === i.swipeDirection &&
                                r.currentTranslate > r.startTranslate &&
                                (r.currentTranslate = r.startTranslate),
                              i.allowSlidePrev ||
                                i.allowSlideNext ||
                                (r.currentTranslate = r.startTranslate),
                              0 < l.threshold)
                            ) {
                              if (
                                !(
                                  Math.abs(s) > l.threshold ||
                                  r.allowThresholdMove
                                )
                              )
                                return void (r.currentTranslate =
                                  r.startTranslate);
                              if (!r.allowThresholdMove)
                                return (
                                  (r.allowThresholdMove = !0),
                                  (n.startX = n.currentX),
                                  (n.startY = n.currentY),
                                  (r.currentTranslate = r.startTranslate),
                                  void (n.diff = i.isHorizontal()
                                    ? n.currentX - n.startX
                                    : n.currentY - n.startY)
                                );
                            }
                            l.followFinger &&
                              !l.cssMode &&
                              (((l.freeMode &&
                                l.freeMode.enabled &&
                                i.freeMode) ||
                                l.watchSlidesProgress) &&
                                (i.updateActiveIndex(),
                                i.updateSlidesClasses()),
                              l.freeMode &&
                                l.freeMode.enabled &&
                                i.freeMode &&
                                i.freeMode.onTouchMove(),
                              i.updateProgress(r.currentTranslate),
                              i.setTranslate(r.currentTranslate));
                          }
                        }
                    }
                  } else
                    a.target.matches(r.focusableElements) ||
                      (i.allowClick = !1),
                      r.isTouched &&
                        (Object.assign(n, {
                          startX: t,
                          startY: d,
                          currentX: t,
                          currentY: d,
                        }),
                        (r.touchStartTime = b()));
                } else
                  r.startMoving &&
                    r.isScrolling &&
                    i.emit("touchMoveOpposite", a);
              }
            }.bind(e)),
            (e.onTouchEnd = function (i) {
              let r = this,
                t = r.touchEventsData,
                e,
                l = i;
              if (
                "touchend" ===
                  (l = l.originalEvent ? l.originalEvent : l).type ||
                "touchcancel" === l.type
              ) {
                if (
                  !(e = [...l.changedTouches].filter(
                    (e) => e.identifier === t.touchId,
                  )[0]) ||
                  e.identifier !== t.touchId
                )
                  return;
              } else {
                if (null !== t.touchId) return;
                if (l.pointerId !== t.pointerId) return;
                e = l;
              }
              if (
                ![
                  "pointercancel",
                  "pointerout",
                  "pointerleave",
                  "contextmenu",
                ].includes(l.type) ||
                (["pointercancel", "contextmenu"].includes(l.type) &&
                  (r.browser.isSafari || r.browser.isWebView))
              ) {
                (t.pointerId = null), (t.touchId = null);
                var {
                  params: n,
                  touches: i,
                  rtlTranslate: s,
                  slidesGrid: o,
                  enabled: d,
                } = r;
                if (d && (n.simulateTouch || "mouse" !== l.pointerType))
                  if (
                    (t.allowTouchCallbacks && r.emit("touchEnd", l),
                    (t.allowTouchCallbacks = !1),
                    t.isTouched)
                  ) {
                    n.grabCursor &&
                      t.isMoved &&
                      t.isTouched &&
                      (!0 === r.allowSlideNext || !0 === r.allowSlidePrev) &&
                      r.setGrabCursor(!1);
                    var p,
                      d = b(),
                      c = d - t.touchStartTime;
                    if (r.allowClick) {
                      let e = l.path || (l.composedPath && l.composedPath());
                      r.updateClickedSlide((e && e[0]) || l.target, e),
                        r.emit("tap click", l),
                        c < 300 &&
                          d - t.lastClickTime < 300 &&
                          r.emit("doubleTap doubleClick", l);
                    }
                    if (
                      ((t.lastClickTime = b()),
                      w(() => {
                        r.destroyed || (r.allowClick = !0);
                      }),
                      t.isTouched &&
                        t.isMoved &&
                        r.swipeDirection &&
                        (0 !== i.diff || t.loopSwapReset) &&
                        (t.currentTranslate !== t.startTranslate ||
                          t.loopSwapReset))
                    ) {
                      if (
                        ((t.isTouched = !1),
                        (t.isMoved = !1),
                        (t.startMoving = !1),
                        (p = n.followFinger
                          ? s
                            ? r.translate
                            : -r.translate
                          : -t.currentTranslate),
                        !n.cssMode)
                      )
                        if (n.freeMode && n.freeMode.enabled)
                          r.freeMode.onTouchEnd({ currentPos: p });
                        else {
                          var u = p >= -r.maxTranslate() && !r.params.loop;
                          let s = 0,
                            a = r.slidesSizesGrid[0];
                          for (
                            let t = 0;
                            t < o.length;
                            t += t < n.slidesPerGroupSkip ? 1 : n.slidesPerGroup
                          ) {
                            let e =
                              t < n.slidesPerGroupSkip - 1
                                ? 1
                                : n.slidesPerGroup;
                            void 0 !== o[t + e]
                              ? (u || (p >= o[t] && p < o[t + e])) &&
                                ((s = t), (a = o[t + e] - o[t]))
                              : (u || p >= o[t]) &&
                                ((s = t),
                                (a = o[o.length - 1] - o[o.length - 2]));
                          }
                          let e = null,
                            t = null;
                          n.rewind &&
                            (r.isBeginning
                              ? (t =
                                  n.virtual && n.virtual.enabled && r.virtual
                                    ? r.virtual.slides.length - 1
                                    : r.slides.length - 1)
                              : r.isEnd && (e = 0));
                          (d = (p - o[s]) / a),
                            (i =
                              s < n.slidesPerGroupSkip - 1
                                ? 1
                                : n.slidesPerGroup);
                          c > n.longSwipesMs
                            ? n.longSwipes
                              ? ("next" === r.swipeDirection &&
                                  (d >= n.longSwipesRatio
                                    ? r.slideTo(n.rewind && r.isEnd ? e : s + i)
                                    : r.slideTo(s)),
                                "prev" === r.swipeDirection &&
                                  (d > 1 - n.longSwipesRatio
                                    ? r.slideTo(s + i)
                                    : null !== t &&
                                        d < 0 &&
                                        Math.abs(d) > n.longSwipesRatio
                                      ? r.slideTo(t)
                                      : r.slideTo(s)))
                              : r.slideTo(r.activeIndex)
                            : n.shortSwipes
                              ? !r.navigation ||
                                (l.target !== r.navigation.nextEl &&
                                  l.target !== r.navigation.prevEl)
                                ? ("next" === r.swipeDirection &&
                                    r.slideTo(null !== e ? e : s + i),
                                  "prev" === r.swipeDirection &&
                                    r.slideTo(null !== t ? t : s))
                                : l.target === r.navigation.nextEl
                                  ? r.slideTo(s + i)
                                  : r.slideTo(s)
                              : r.slideTo(r.activeIndex);
                        }
                    } else
                      (t.isTouched = !1),
                        (t.isMoved = !1),
                        (t.startMoving = !1);
                  } else
                    t.isMoved && n.grabCursor && r.setGrabCursor(!1),
                      (t.isMoved = !1),
                      (t.startMoving = !1);
              }
            }.bind(e)),
            (e.onDocumentTouchStart = function () {
              this.documentTouchHandlerProceeded ||
                ((this.documentTouchHandlerProceeded = !0),
                this.params.touchReleaseOnEdges &&
                  (this.el.style.touchAction = "auto"));
            }.bind(e)),
            t.cssMode &&
              (e.onScroll = function () {
                var e = this,
                  { wrapperEl: t, rtlTranslate: s, enabled: a } = e;
                a &&
                  ((e.previousTranslate = e.translate),
                  e.isHorizontal()
                    ? (e.translate = -t.scrollLeft)
                    : (e.translate = -t.scrollTop),
                  0 === e.translate && (e.translate = 0),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses(),
                  (0 == (a = e.maxTranslate() - e.minTranslate())
                    ? 0
                    : (e.translate - e.minTranslate()) / a) !== e.progress &&
                    e.updateProgress(s ? -e.translate : e.translate),
                  e.emit("setTranslate", e.translate, !1));
              }.bind(e)),
            (e.onClick = function (e) {
              var t = this;
              t.enabled &&
                !t.allowClick &&
                (t.params.preventClicks && e.preventDefault(),
                t.params.preventClicksPropagation) &&
                t.animating &&
                (e.stopPropagation(), e.stopImmediatePropagation());
            }.bind(e)),
            (e.onLoad = function (e) {
              var t = this;
              n(t, e.target),
                t.params.cssMode ||
                  ("auto" !== t.params.slidesPerView && !t.params.autoHeight) ||
                  t.update();
            }.bind(e)),
            Y(e, "on");
        },
        detachEvents: function () {
          Y(this, "off");
        },
      },
      breakpoints: {
        setBreakpoint: function () {
          let l = this,
            { realIndex: n, initialized: o, params: d, el: p } = l,
            c = d.breakpoints;
          if (c && 0 !== Object.keys(c).length) {
            var u = l.getBreakpoint(c, l.params.breakpointsBase, l.el);
            if (u && l.currentBreakpoint !== u) {
              let a = (u in c ? c[u] : void 0) || l.originalParams,
                e = W(l, d),
                t = W(l, a),
                s = l.params.grabCursor,
                i = a.grabCursor,
                r = d.enabled;
              e && !t
                ? (p.classList.remove(
                    d.containerModifierClass + "grid",
                    d.containerModifierClass + "grid-column",
                  ),
                  l.emitContainerClasses())
                : !e &&
                  t &&
                  (p.classList.add(d.containerModifierClass + "grid"),
                  ((a.grid.fill && "column" === a.grid.fill) ||
                    (!a.grid.fill && "column" === d.grid.fill)) &&
                    p.classList.add(d.containerModifierClass + "grid-column"),
                  l.emitContainerClasses()),
                s && !i ? l.unsetGrabCursor() : !s && i && l.setGrabCursor(),
                ["navigation", "pagination", "scrollbar"].forEach((e) => {
                  var t, s;
                  void 0 !== a[e] &&
                    ((t = d[e] && d[e].enabled),
                    (s = a[e] && a[e].enabled),
                    t && !s && l[e].disable(),
                    !t) &&
                    s &&
                    l[e].enable();
                });
              var m = a.direction && a.direction !== d.direction,
                h = d.loop && (a.slidesPerView !== d.slidesPerView || m),
                f = d.loop,
                m =
                  (m && o && l.changeDirection(),
                  y(l.params, a),
                  l.params.enabled),
                v = l.params.loop;
              Object.assign(l, {
                allowTouchMove: l.params.allowTouchMove,
                allowSlideNext: l.params.allowSlideNext,
                allowSlidePrev: l.params.allowSlidePrev,
              }),
                r && !m ? l.disable() : !r && m && l.enable(),
                (l.currentBreakpoint = u),
                l.emit("_beforeBreakpoint", a),
                o &&
                  (h
                    ? (l.loopDestroy(), l.loopCreate(n), l.updateSlides())
                    : !f && v
                      ? (l.loopCreate(n), l.updateSlides())
                      : f && !v && l.loopDestroy()),
                l.emit("breakpoint", a);
            }
          }
        },
        getBreakpoint: function (e, l, n) {
          if ((void 0 === l && (l = "window"), e && ("container" !== l || n))) {
            let a = !1,
              i = g(),
              s = "window" === l ? i.innerHeight : n.clientHeight,
              r = Object.keys(e).map((e) => {
                var t;
                return "string" == typeof e && 0 === e.indexOf("@")
                  ? ((t = parseFloat(e.substr(1))), { value: s * t, point: e })
                  : { value: e, point: e };
              });
            r.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
            for (let s = 0; s < r.length; s += 1) {
              let { point: e, value: t } = r[s];
              "window" === l
                ? i.matchMedia(`(min-width: ${t}px)`).matches && (a = e)
                : t <= n.clientWidth && (a = e);
            }
            return a || "max";
          }
        },
      },
      checkOverflow: {
        checkOverflow: function () {
          let s = this,
            { isLocked: e, params: t } = s,
            a = t.slidesOffsetBefore;
          if (a) {
            let e = s.slides.length - 1,
              t = s.slidesGrid[e] + s.slidesSizesGrid[e] + 2 * a;
            s.isLocked = s.size > t;
          } else s.isLocked = 1 === s.snapGrid.length;
          !0 === t.allowSlideNext && (s.allowSlideNext = !s.isLocked),
            !0 === t.allowSlidePrev && (s.allowSlidePrev = !s.isLocked),
            e && e !== s.isLocked && (s.isEnd = !1),
            e !== s.isLocked && s.emit(s.isLocked ? "lock" : "unlock");
        },
      },
      classes: {
        addClasses: function () {
          var { classNames: e, params: t, rtl: s, el: a, device: i } = this,
            s = ((e, s) => {
              let a = [];
              return (
                e.forEach((t) => {
                  "object" == typeof t
                    ? Object.keys(t).forEach((e) => {
                        t[e] && a.push(s + e);
                      })
                    : "string" == typeof t && a.push(s + t);
                }),
                a
              );
            })(
              [
                "initialized",
                t.direction,
                { "free-mode": this.params.freeMode && t.freeMode.enabled },
                { autoheight: t.autoHeight },
                { rtl: s },
                { grid: t.grid && 1 < t.grid.rows },
                {
                  "grid-column":
                    t.grid && 1 < t.grid.rows && "column" === t.grid.fill,
                },
                { android: i.android },
                { ios: i.ios },
                { "css-mode": t.cssMode },
                { centered: t.cssMode && t.centeredSlides },
                { "watch-progress": t.watchSlidesProgress },
              ],
              t.containerModifierClass,
            );
          e.push(...s), a.classList.add(...e), this.emitContainerClasses();
        },
        removeClasses: function () {
          var { el: e, classNames: t } = this;
          e &&
            "string" != typeof e &&
            (e.classList.remove(...t), this.emitContainerClasses());
        },
      },
    },
    E = {};
  class M {
    constructor() {
      let e, s;
      for (var t = arguments.length, a = new Array(t), i = 0; i < t; i++)
        a[i] = arguments[i];
      1 === a.length &&
      a[0].constructor &&
      "Object" === Object.prototype.toString.call(a[0]).slice(8, -1)
        ? (s = a[0])
        : ([e, s] = a),
        (s = y({}, (s = s || {}))),
        e && !s.el && (s.el = e);
      var r = I();
      if (
        s.el &&
        "string" == typeof s.el &&
        1 < r.querySelectorAll(s.el).length
      ) {
        let t = [];
        return (
          r.querySelectorAll(s.el).forEach((e) => {
            e = y({}, s, { el: e });
            t.push(new M(e));
          }),
          t
        );
      }
      let l = this,
        n =
          ((l.__swiper__ = !0),
          (l.support = u()),
          (l.device = F({ userAgent: s.userAgent })),
          (l.browser = N()),
          (l.eventsListeners = {}),
          (l.eventsAnyListeners = []),
          (l.modules = [...l.__modules__]),
          s.modules && Array.isArray(s.modules) && l.modules.push(...s.modules),
          {});
      l.modules.forEach((e) => {
        var a, i;
        e({
          params: s,
          swiper: l,
          extendParams:
            ((a = s),
            (i = n),
            function (e) {
              void 0 === e && (e = {});
              var t = Object.keys(e)[0],
                s = e[t];
              "object" == typeof s &&
                null !== s &&
                (!0 === a[t] && (a[t] = { enabled: !0 }),
                "navigation" === t &&
                  a[t] &&
                  a[t].enabled &&
                  !a[t].prevEl &&
                  !a[t].nextEl &&
                  (a[t].auto = !0),
                0 <= ["pagination", "scrollbar"].indexOf(t) &&
                  a[t] &&
                  a[t].enabled &&
                  !a[t].el &&
                  (a[t].auto = !0),
                t in a) &&
                "enabled" in s &&
                ("object" != typeof a[t] ||
                  "enabled" in a[t] ||
                  (a[t].enabled = !0),
                a[t] || (a[t] = { enabled: !1 })),
                y(i, e);
            }),
          on: l.on.bind(l),
          once: l.once.bind(l),
          off: l.off.bind(l),
          emit: l.emit.bind(l),
        });
      });
      r = y({}, U, n);
      return (
        (l.params = y({}, r, E, s)),
        (l.originalParams = y({}, l.params)),
        (l.passedParams = y({}, s)),
        l.params &&
          l.params.on &&
          Object.keys(l.params.on).forEach((e) => {
            l.on(e, l.params.on[e]);
          }),
        l.params && l.params.onAny && l.onAny(l.params.onAny),
        Object.assign(l, {
          enabled: l.params.enabled,
          el: e,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => "horizontal" === l.params.direction,
          isVertical: () => "vertical" === l.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          allowSlideNext: l.params.allowSlideNext,
          allowSlidePrev: l.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: l.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            pointerId: null,
            touchId: null,
          },
          allowClick: !0,
          allowTouchMove: l.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        l.emit("_swiper"),
        l.params.init && l.init(),
        l
      );
    }
    getDirectionLabel(e) {
      return this.isHorizontal()
        ? e
        : {
            width: "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            marginRight: "marginBottom",
          }[e];
    }
    getSlideIndex(e) {
      var { slidesEl: t, params: s } = this,
        t = f(A(t, `.${s.slideClass}, swiper-slide`)[0]);
      return f(e) - t;
    }
    getSlideIndexByData(t) {
      return this.getSlideIndex(
        this.slides.filter(
          (e) => +e.getAttribute("data-swiper-slide-index") === t,
        )[0],
      );
    }
    recalcSlides() {
      var { slidesEl: e, params: t } = this;
      this.slides = A(e, `.${t.slideClass}, swiper-slide`);
    }
    enable() {
      var e = this;
      e.enabled ||
        ((e.enabled = !0),
        e.params.grabCursor && e.setGrabCursor(),
        e.emit("enable"));
    }
    disable() {
      var e = this;
      e.enabled &&
        ((e.enabled = !1),
        e.params.grabCursor && e.unsetGrabCursor(),
        e.emit("disable"));
    }
    setProgress(e, t) {
      var s = this,
        a = ((e = Math.min(Math.max(e, 0), 1)), s.minTranslate()),
        e = (s.maxTranslate() - a) * e + a;
      s.translateTo(e, void 0 === t ? 0 : t),
        s.updateActiveIndex(),
        s.updateSlidesClasses();
    }
    emitContainerClasses() {
      let t = this;
      var e;
      t.params._emitClasses &&
        t.el &&
        ((e = t.el.className
          .split(" ")
          .filter(
            (e) =>
              0 === e.indexOf("swiper") ||
              0 === e.indexOf(t.params.containerModifierClass),
          )),
        t.emit("_containerClasses", e.join(" ")));
    }
    getSlideClasses(e) {
      let t = this;
      return t.destroyed
        ? ""
        : e.className
            .split(" ")
            .filter(
              (e) =>
                0 === e.indexOf("swiper-slide") ||
                0 === e.indexOf(t.params.slideClass),
            )
            .join(" ");
    }
    emitSlidesClasses() {
      let a = this;
      if (a.params._emitClasses && a.el) {
        let s = [];
        a.slides.forEach((e) => {
          var t = a.getSlideClasses(e);
          s.push({ slideEl: e, classNames: t }), a.emit("_slideClass", e, t);
        }),
          a.emit("_slideClasses", s);
      }
    }
    slidesPerViewDynamic(e, t) {
      void 0 === e && (e = "current"), void 0 === t && (t = !1);
      var {
        params: s,
        slides: a,
        slidesGrid: i,
        slidesSizesGrid: r,
        size: l,
        activeIndex: n,
      } = this;
      let o = 1;
      if ("number" == typeof s.slidesPerView) return s.slidesPerView;
      if (s.centeredSlides) {
        let t,
          s = a[n] ? Math.ceil(a[n].swiperSlideSize) : 0;
        for (let e = n + 1; e < a.length; e += 1)
          a[e] &&
            !t &&
            ((s += Math.ceil(a[e].swiperSlideSize)), (o += 1), s > l) &&
            (t = !0);
        for (let e = n - 1; 0 <= e; --e)
          a[e] &&
            !t &&
            ((s += a[e].swiperSlideSize), (o += 1), s > l) &&
            (t = !0);
      } else if ("current" === e)
        for (let e = n + 1; e < a.length; e += 1)
          (t ? i[e] + r[e] - i[n] < l : i[e] - i[n] < l) && (o += 1);
      else for (let e = n - 1; 0 <= e; --e) i[n] - i[e] < l && (o += 1);
      return o;
    }
    update() {
      let a = this;
      if (a && !a.destroyed) {
        let { snapGrid: e, params: t } = a,
          s;
        if (
          (t.breakpoints && a.setBreakpoint(),
          [...a.el.querySelectorAll('[loading="lazy"]')].forEach((e) => {
            e.complete && n(a, e);
          }),
          a.updateSize(),
          a.updateSlides(),
          a.updateProgress(),
          a.updateSlidesClasses(),
          t.freeMode && t.freeMode.enabled && !t.cssMode)
        )
          i(), t.autoHeight && a.updateAutoHeight();
        else {
          if (
            ("auto" === t.slidesPerView || 1 < t.slidesPerView) &&
            a.isEnd &&
            !t.centeredSlides
          ) {
            let e = (a.virtual && t.virtual.enabled ? a.virtual : a).slides;
            s = a.slideTo(e.length - 1, 0, !1, !0);
          } else s = a.slideTo(a.activeIndex, 0, !1, !0);
          s || i();
        }
        function i() {
          var e = a.rtlTranslate ? -1 * a.translate : a.translate,
            e = Math.min(Math.max(e, a.maxTranslate()), a.minTranslate());
          a.setTranslate(e), a.updateActiveIndex(), a.updateSlidesClasses();
        }
        t.watchOverflow && e !== a.snapGrid && a.checkOverflow(),
          a.emit("update");
      }
    }
    changeDirection(t, e) {
      void 0 === e && (e = !0);
      var s = this,
        a = s.params.direction;
      return (
        (t = t || ("horizontal" === a ? "vertical" : "horizontal")) === a ||
          ("horizontal" !== t && "vertical" !== t) ||
          (s.el.classList.remove("" + s.params.containerModifierClass + a),
          s.el.classList.add("" + s.params.containerModifierClass + t),
          s.emitContainerClasses(),
          (s.params.direction = t),
          s.slides.forEach((e) => {
            "vertical" === t ? (e.style.width = "") : (e.style.height = "");
          }),
          s.emit("changeDirection"),
          e && s.update()),
        s
      );
    }
    changeLanguageDirection(e) {
      var t = this;
      (t.rtl && "rtl" === e) ||
        (!t.rtl && "ltr" === e) ||
        ((t.rtl = "rtl" === e),
        (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
        t.rtl
          ? (t.el.classList.add(t.params.containerModifierClass + "rtl"),
            (t.el.dir = "rtl"))
          : (t.el.classList.remove(t.params.containerModifierClass + "rtl"),
            (t.el.dir = "ltr")),
        t.update());
    }
    mount(a) {
      let i = this;
      if (!i.mounted) {
        let e = a || i.params.el;
        if (!(e = "string" == typeof e ? document.querySelector(e) : e))
          return !1;
        (e.swiper = i),
          e.parentNode &&
            e.parentNode.host &&
            e.parentNode.host.nodeName ===
              i.params.swiperElementNodeName.toUpperCase() &&
            (i.isElement = !0);
        let t = () =>
            "." + (i.params.wrapperClass || "").trim().split(" ").join("."),
          s =
            e && e.shadowRoot && e.shadowRoot.querySelector
              ? e.shadowRoot.querySelector(t())
              : A(e, t())[0];
        !s &&
          i.params.createElements &&
          ((s = p("div", i.params.wrapperClass)),
          e.append(s),
          A(e, "." + i.params.slideClass).forEach((e) => {
            s.append(e);
          })),
          Object.assign(i, {
            el: e,
            wrapperEl: s,
            slidesEl:
              i.isElement && !e.parentNode.host.slideSlots
                ? e.parentNode.host
                : s,
            hostEl: i.isElement ? e.parentNode.host : e,
            mounted: !0,
            rtl: "rtl" === e.dir.toLowerCase() || "rtl" === C(e, "direction"),
            rtlTranslate:
              "horizontal" === i.params.direction &&
              ("rtl" === e.dir.toLowerCase() || "rtl" === C(e, "direction")),
            wrongRTL: "-webkit-box" === C(s, "display"),
          });
      }
      return !0;
    }
    init(e) {
      let t = this;
      return (
        t.initialized ||
          (!1 !== t.mount(e) &&
            (t.emit("beforeInit"),
            t.params.breakpoints && t.setBreakpoint(),
            t.addClasses(),
            t.updateSize(),
            t.updateSlides(),
            t.params.watchOverflow && t.checkOverflow(),
            t.params.grabCursor && t.enabled && t.setGrabCursor(),
            t.params.loop && t.virtual && t.params.virtual.enabled
              ? t.slideTo(
                  t.params.initialSlide + t.virtual.slidesBefore,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0,
                )
              : t.slideTo(
                  t.params.initialSlide,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0,
                ),
            t.params.loop && t.loopCreate(),
            t.attachEvents(),
            (e = [...t.el.querySelectorAll('[loading="lazy"]')]),
            t.isElement &&
              e.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),
            e.forEach((e) => {
              e.complete
                ? n(t, e)
                : e.addEventListener("load", (e) => {
                    n(t, e.target);
                  });
            }),
            m(t),
            (t.initialized = !0),
            m(t),
            t.emit("init"),
            t.emit("afterInit"))),
        t
      );
    }
    destroy(e, t) {
      void 0 === e && (e = !0), void 0 === t && (t = !0);
      let s = this,
        { params: a, el: i, wrapperEl: r, slides: l } = s;
      if (void 0 !== s.params && !s.destroyed) {
        if (
          (s.emit("beforeDestroy"),
          (s.initialized = !1),
          s.detachEvents(),
          a.loop && s.loopDestroy(),
          t &&
            (s.removeClasses(),
            i && "string" != typeof i && i.removeAttribute("style"),
            r && r.removeAttribute("style"),
            l) &&
            l.length &&
            l.forEach((e) => {
              e.classList.remove(
                a.slideVisibleClass,
                a.slideFullyVisibleClass,
                a.slideActiveClass,
                a.slideNextClass,
                a.slidePrevClass,
              ),
                e.removeAttribute("style"),
                e.removeAttribute("data-swiper-slide-index");
            }),
          s.emit("destroy"),
          Object.keys(s.eventsListeners).forEach((e) => {
            s.off(e);
          }),
          !1 !== e)
        ) {
          s.el && "string" != typeof s.el && (s.el.swiper = null);
          {
            let t = s;
            Object.keys(t).forEach((e) => {
              try {
                t[e] = null;
              } catch (e) {}
              try {
                delete t[e];
              } catch (e) {}
            });
          }
        }
        s.destroyed = !0;
      }
      return null;
    }
    static extendDefaults(e) {
      y(E, e);
    }
    static get extendedDefaults() {
      return E;
    }
    static get defaults() {
      return U;
    }
    static installModule(e) {
      M.prototype.__modules__ || (M.prototype.__modules__ = []);
      var t = M.prototype.__modules__;
      "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
      return (
        Array.isArray(e)
          ? e.forEach((e) => M.installModule(e))
          : M.installModule(e),
        M
      );
    }
  }
  function K(s, a, i, r) {
    return (
      s.params.createElements &&
        Object.keys(r).forEach((t) => {
          if (!i[t] && !0 === i.auto) {
            let e = A(s.el, "." + r[t])[0];
            e || (((e = p("div", r[t])).className = r[t]), s.el.append(e)),
              (i[t] = e),
              (a[t] = e);
          }
        }),
      i
    );
  }
  function k(e) {
    return (
      "." +
      (e = void 0 === e ? "" : e)
        .trim()
        .replace(/([\.:!+\/])/g, "\\$1")
        .replace(/ /g, ".")
    );
  }
  function z(e) {
    let {
        effect: s,
        swiper: a,
        on: t,
        setTranslate: i,
        setTransition: r,
        overwriteParams: l,
        perspective: n,
        recreateShadows: o,
        getEffectParams: d,
      } = e,
      p;
    t("beforeInit", () => {
      var e;
      a.params.effect === s &&
        (a.classNames.push("" + a.params.containerModifierClass + s),
        n && n() && a.classNames.push(a.params.containerModifierClass + "3d"),
        (e = l ? l() : {}),
        Object.assign(a.params, e),
        Object.assign(a.originalParams, e));
    }),
      t("setTranslate", () => {
        a.params.effect === s && i();
      }),
      t("setTransition", (e, t) => {
        a.params.effect === s && r(t);
      }),
      t("transitionEnd", () => {
        a.params.effect === s &&
          o &&
          d &&
          d().slideShadows &&
          (a.slides.forEach((e) => {
            e.querySelectorAll(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left",
            ).forEach((e) => e.remove());
          }),
          o());
      }),
      t("virtualUpdate", () => {
        a.params.effect === s &&
          (a.slides.length || (p = !0),
          requestAnimationFrame(() => {
            p && a.slides && a.slides.length && (i(), (p = !1));
          }));
      });
  }
  function D(e, t) {
    var s = r(t);
    return (
      s !== t &&
        ((s.style.backfaceVisibility = "hidden"),
        (s.style["-webkit-backface-visibility"] = "hidden")),
      s
    );
  }
  function Z(e) {
    let { swiper: s, duration: t, transformElements: a, allSlides: i } = e,
      r = s.activeIndex;
    if (s.params.virtualTranslate && 0 !== t) {
      let t = !1;
      (i
        ? a
        : a.filter((e) => {
            var t,
              e = e.classList.contains("swiper-slide-transform")
                ? (t = e).parentElement ||
                  s.slides.filter(
                    (e) => e.shadowRoot && e.shadowRoot === t.parentNode,
                  )[0]
                : e;
            return s.getSlideIndex(e) === r;
          })
      ).forEach((e) => {
        x(e, () => {
          var e;
          t ||
            (s &&
              !s.destroyed &&
              ((t = !0),
              (s.animating = !1),
              (e = new window.CustomEvent("transitionend", {
                bubbles: !0,
                cancelable: !0,
              })),
              s.wrapperEl.dispatchEvent(e)));
        });
      });
    }
  }
  function G(e, t, s) {
    (s =
      "swiper-slide-shadow" +
      (s ? "-" + s : "") +
      (e ? " swiper-slide-shadow-" + e : "")),
      (e = r(t));
    let a = e.querySelector("." + s.split(" ").join("."));
    return a || ((a = p("div", s.split(" "))), e.append(a)), a;
  }
  return (
    Object.keys(h).forEach((t) => {
      Object.keys(h[t]).forEach((e) => {
        M.prototype[e] = h[t][e];
      });
    }),
    M.use([
      function (e) {
        let { swiper: r, on: t, emit: s } = e,
          a = g(),
          i = null,
          l = null,
          n = () => {
            r &&
              !r.destroyed &&
              r.initialized &&
              (s("beforeResize"), s("resize"));
          },
          o = () => {
            r && !r.destroyed && r.initialized && s("orientationchange");
          };
        t("init", () => {
          r.params.resizeObserver && void 0 !== a.ResizeObserver
            ? r &&
              !r.destroyed &&
              r.initialized &&
              (i = new ResizeObserver((s) => {
                l = a.requestAnimationFrame(() => {
                  var { width: e, height: t } = r;
                  let a = e,
                    i = t;
                  s.forEach((e) => {
                    var { contentBoxSize: e, contentRect: t, target: s } = e;
                    (s && s !== r.el) ||
                      ((a = t ? t.width : (e[0] || e).inlineSize),
                      (i = t ? t.height : (e[0] || e).blockSize));
                  }),
                    (a === e && i === t) || n();
                });
              })).observe(r.el)
            : (a.addEventListener("resize", n),
              a.addEventListener("orientationchange", o));
        }),
          t("destroy", () => {
            l && a.cancelAnimationFrame(l),
              i && i.unobserve && r.el && (i.unobserve(r.el), (i = null)),
              a.removeEventListener("resize", n),
              a.removeEventListener("orientationchange", o);
          });
      },
      function (e) {
        function s(e, t) {
          void 0 === t && (t = {});
          var s = new (n.MutationObserver || n.WebkitMutationObserver)((e) => {
            var t;
            a.__preventObserver__ ||
              (1 === e.length
                ? r("observerUpdate", e[0])
                : ((t = function () {
                    r("observerUpdate", e[0]);
                  }),
                  n.requestAnimationFrame
                    ? n.requestAnimationFrame(t)
                    : n.setTimeout(t, 0)));
          });
          s.observe(e, {
            attributes: void 0 === t.attributes || t.attributes,
            childList: void 0 === t.childList || t.childList,
            characterData: void 0 === t.characterData || t.characterData,
          }),
            l.push(s);
        }
        let { swiper: a, extendParams: t, on: i, emit: r } = e,
          l = [],
          n = g();
        t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          i("init", () => {
            if (a.params.observer) {
              if (a.params.observeParents) {
                var t = v(a.hostEl);
                for (let e = 0; e < t.length; e += 1) s(t[e]);
              }
              s(a.hostEl, { childList: a.params.observeSlideChildren }),
                s(a.wrapperEl, { attributes: !1 });
            }
          }),
          i("destroy", () => {
            l.forEach((e) => {
              e.disconnect();
            }),
              l.splice(0, l.length);
          });
      },
    ]),
    M.use([
      function (e) {
        let t,
          { swiper: M, extendParams: s, on: a, emit: C } = e;
        s({
          virtual: {
            enabled: !1,
            slides: [],
            cache: !0,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: !0,
            addSlidesBefore: 0,
            addSlidesAfter: 0,
          },
        });
        e = I();
        M.virtual = {
          cache: {},
          from: void 0,
          to: void 0,
          slides: [],
          offset: 0,
          slidesGrid: [],
        };
        let i = e.createElement("div");
        function P(e, t) {
          var s = M.params.virtual;
          if (s.cache && M.virtual.cache[t]) return M.virtual.cache[t];
          let a;
          return (
            s.renderSlide
              ? "string" == typeof (a = s.renderSlide.call(M, e, t)) &&
                ((i.innerHTML = a), (a = i.children[0]))
              : (a = M.isElement
                  ? p("swiper-slide")
                  : p("div", M.params.slideClass)),
            a.setAttribute("data-swiper-slide-index", t),
            s.renderSlide || (a.innerHTML = e),
            s.cache && (M.virtual.cache[t] = a),
            a
          );
        }
        function l(m, h) {
          var {
            slidesPerView: f,
            slidesPerGroup: v,
            centeredSlides: g,
            loop: w,
            initialSlide: b,
          } = M.params;
          if (!(h && !w && 0 < b)) {
            let { addSlidesBefore: e, addSlidesAfter: t } = M.params.virtual,
              {
                from: s,
                to: a,
                slides: i,
                slidesGrid: r,
                offset: l,
              } = M.virtual;
            M.params.cssMode || M.updateActiveIndex();
            h = M.activeIndex || 0;
            let n,
              o,
              d,
              p =
                ((n = M.rtlTranslate
                  ? "right"
                  : M.isHorizontal()
                    ? "left"
                    : "top"),
                h -
                  (d = g
                    ? ((o = Math.floor(f / 2) + v + t),
                      Math.floor(f / 2) + v + e)
                    : ((o = f + (v - 1) + t), (w ? f : v) + e))),
              c = h + o,
              u =
                (w || ((p = Math.max(p, 0)), (c = Math.min(c, i.length - 1))),
                (M.slidesGrid[p] || 0) - (M.slidesGrid[0] || 0));
            if (
              (w && h >= d
                ? ((p -= d), g || (u += M.slidesGrid[0]))
                : w && h < d && ((p = -d), g) && (u += M.slidesGrid[0]),
              Object.assign(M.virtual, {
                from: p,
                to: c,
                offset: u,
                slidesGrid: M.slidesGrid,
                slidesBefore: d,
                slidesAfter: o,
              }),
              s !== p || a !== c || m)
            )
              if (M.params.virtual.renderExternal)
                M.params.virtual.renderExternal.call(M, {
                  offset: u,
                  from: p,
                  to: c,
                  slides: (() => {
                    var t = [];
                    for (let e = p; e <= c; e += 1) t.push(i[e]);
                    return t;
                  })(),
                }),
                  M.params.virtual.renderExternalUpdate
                    ? E()
                    : C("virtualUpdate");
              else {
                var y = [],
                  T = [],
                  x = (e) => {
                    let t = e;
                    return (
                      e < 0
                        ? (t = i.length + e)
                        : t >= i.length && (t -= i.length),
                      t
                    );
                  };
                if (m)
                  M.slides
                    .filter((e) =>
                      e.matches(`.${M.params.slideClass}, swiper-slide`),
                    )
                    .forEach((e) => {
                      e.remove();
                    });
                else
                  for (let e = s; e <= a; e += 1)
                    if (e < p || e > c) {
                      let t = x(e);
                      M.slides
                        .filter((e) =>
                          e.matches(
                            `.${M.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`,
                          ),
                        )
                        .forEach((e) => {
                          e.remove();
                        });
                    }
                var b = w ? -i.length : 0,
                  S = w ? 2 * i.length : i.length;
                for (let t = b; t < S; t += 1)
                  if (t >= p && t <= c) {
                    let e = x(t);
                    void 0 === a || m
                      ? T.push(e)
                      : (t > a && T.push(e), t < s && y.push(e));
                  }
                if (
                  (T.forEach((e) => {
                    M.slidesEl.append(P(i[e], e));
                  }),
                  w)
                )
                  for (let t = y.length - 1; 0 <= t; --t) {
                    let e = y[t];
                    M.slidesEl.prepend(P(i[e], e));
                  }
                else
                  y.sort((e, t) => t - e),
                    y.forEach((e) => {
                      M.slidesEl.prepend(P(i[e], e));
                    });
                A(M.slidesEl, ".swiper-slide, swiper-slide").forEach((e) => {
                  e.style[n] = u - Math.abs(M.cssOverflowAdjustment()) + "px";
                }),
                  E();
              }
            else
              M.slidesGrid !== r &&
                u !== l &&
                M.slides.forEach((e) => {
                  e.style[n] = u - Math.abs(M.cssOverflowAdjustment()) + "px";
                }),
                M.updateProgress(),
                C("virtualUpdate");
            function E() {
              M.updateSlides(),
                M.updateProgress(),
                M.updateSlidesClasses(),
                C("virtualUpdate");
            }
          }
        }
        a("beforeInit", () => {
          if (M.params.virtual.enabled) {
            let e;
            var t;
            void 0 === M.passedParams.virtual.slides &&
              (t = [...M.slidesEl.children].filter((e) =>
                e.matches(`.${M.params.slideClass}, swiper-slide`),
              )) &&
              t.length &&
              ((M.virtual.slides = [...t]),
              (e = !0),
              t.forEach((e, t) => {
                e.setAttribute("data-swiper-slide-index", t),
                  (M.virtual.cache[t] = e).remove();
              })),
              e || (M.virtual.slides = M.params.virtual.slides),
              M.classNames.push(M.params.containerModifierClass + "virtual"),
              (M.params.watchSlidesProgress = !0),
              l(!(M.originalParams.watchSlidesProgress = !0), !0);
          }
        }),
          a("setTranslate", () => {
            M.params.virtual.enabled &&
              (M.params.cssMode && !M._immediateVirtual
                ? (clearTimeout(t),
                  (t = setTimeout(() => {
                    l();
                  }, 100)))
                : l());
          }),
          a("init update resize", () => {
            M.params.virtual.enabled &&
              M.params.cssMode &&
              L(M.wrapperEl, "--swiper-virtual-size", M.virtualSize + "px");
          }),
          Object.assign(M.virtual, {
            appendSlide: function (t) {
              if ("object" == typeof t && "length" in t)
                for (let e = 0; e < t.length; e += 1)
                  t[e] && M.virtual.slides.push(t[e]);
              else M.virtual.slides.push(t);
              l(!0);
            },
            prependSlide: function (t) {
              let e = M.activeIndex,
                s = e + 1,
                r = 1;
              if (Array.isArray(t)) {
                for (let e = 0; e < t.length; e += 1)
                  t[e] && M.virtual.slides.unshift(t[e]);
                (s = e + t.length), (r = t.length);
              } else M.virtual.slides.unshift(t);
              if (M.params.virtual.cache) {
                let a = M.virtual.cache,
                  i = {};
                Object.keys(a).forEach((e) => {
                  var t = a[e],
                    s = t.getAttribute("data-swiper-slide-index");
                  s &&
                    t.setAttribute(
                      "data-swiper-slide-index",
                      parseInt(s, 10) + r,
                    ),
                    (i[parseInt(e, 10) + r] = t);
                }),
                  (M.virtual.cache = i);
              }
              l(!0), M.slideTo(s, 0);
            },
            removeSlide: function (s) {
              if (null != s) {
                let t = M.activeIndex;
                if (Array.isArray(s))
                  for (let e = s.length - 1; 0 <= e; --e)
                    M.params.virtual.cache &&
                      (delete M.virtual.cache[s[e]],
                      Object.keys(M.virtual.cache).forEach((e) => {
                        s < e &&
                          ((M.virtual.cache[e - 1] = M.virtual.cache[e]),
                          M.virtual.cache[e - 1].setAttribute(
                            "data-swiper-slide-index",
                            e - 1,
                          ),
                          delete M.virtual.cache[e]);
                      })),
                      M.virtual.slides.splice(s[e], 1),
                      s[e] < t && --t,
                      (t = Math.max(t, 0));
                else
                  M.params.virtual.cache &&
                    (delete M.virtual.cache[s],
                    Object.keys(M.virtual.cache).forEach((e) => {
                      s < e &&
                        ((M.virtual.cache[e - 1] = M.virtual.cache[e]),
                        M.virtual.cache[e - 1].setAttribute(
                          "data-swiper-slide-index",
                          e - 1,
                        ),
                        delete M.virtual.cache[e]);
                    })),
                    M.virtual.slides.splice(s, 1),
                    s < t && --t,
                    (t = Math.max(t, 0));
                l(!0), M.slideTo(t, 0);
              }
            },
            removeAllSlides: function () {
              (M.virtual.slides = []),
                M.params.virtual.cache && (M.virtual.cache = {}),
                l(!0),
                M.slideTo(0, 0);
            },
            update: l,
          });
      },
      function (e) {
        let { swiper: p, extendParams: t, on: s, emit: c } = e,
          a = g(),
          u;
        t({
          mousewheel: {
            enabled: !1,
            releaseOnEdges: !1,
            invert: !1,
            forceToAxis: !1,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel",
          },
        }),
          (p.mousewheel = { enabled: !1 });
        let m,
          i = b(),
          h = [];
        function r() {
          p.enabled && (p.mouseEntered = !0);
        }
        function l() {
          p.enabled && (p.mouseEntered = !1);
        }
        function f(e) {
          (p.params.mousewheel.thresholdDelta &&
            e.delta < p.params.mousewheel.thresholdDelta) ||
            (p.params.mousewheel.thresholdTime &&
              b() - i < p.params.mousewheel.thresholdTime) ||
            (6 <= e.delta && b() - i < 60) ||
            (e.direction < 0
              ? (p.isEnd && !p.params.loop) ||
                p.animating ||
                (p.slideNext(), c("scroll", e.raw))
              : (p.isBeginning && !p.params.loop) ||
                p.animating ||
                (p.slidePrev(), c("scroll", e.raw)),
            (i = new a.Date().getTime()));
        }
        function n(a) {
          let l = a,
            i = !0;
          if (
            p.enabled &&
            !a.target.closest("." + p.params.mousewheel.noMousewheelClass)
          ) {
            var n = p.params.mousewheel;
            p.params.cssMode && l.preventDefault();
            let e = p.el,
              t =
                (e =
                  "container" !== p.params.mousewheel.eventsTarget
                    ? document.querySelector(p.params.mousewheel.eventsTarget)
                    : e) && e.contains(l.target);
            if (!p.mouseEntered && !t && !n.releaseOnEdges) return !0;
            l.originalEvent && (l = l.originalEvent);
            let r = 0;
            var o = p.rtlTranslate ? -1 : 1,
              d = ((e) => {
                let t = 0,
                  s = 0,
                  a = 0,
                  i = 0;
                return (
                  "detail" in e && (s = e.detail),
                  "wheelDelta" in e && (s = -e.wheelDelta / 120),
                  "wheelDeltaY" in e && (s = -e.wheelDeltaY / 120),
                  "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
                  "axis" in e &&
                    e.axis === e.HORIZONTAL_AXIS &&
                    ((t = s), (s = 0)),
                  (a = 10 * t),
                  (i = 10 * s),
                  "deltaY" in e && (i = e.deltaY),
                  "deltaX" in e && (a = e.deltaX),
                  e.shiftKey && !a && ((a = i), (i = 0)),
                  (a || i) &&
                    e.deltaMode &&
                    (1 === e.deltaMode
                      ? ((a *= 40), (i *= 40))
                      : ((a *= 800), (i *= 800))),
                  a && !t && (t = a < 1 ? -1 : 1),
                  i && !s && (s = i < 1 ? -1 : 1),
                  { spinX: t, spinY: s, pixelX: a, pixelY: i }
                );
              })(l);
            if (n.forceToAxis)
              if (p.isHorizontal()) {
                if (!(Math.abs(d.pixelX) > Math.abs(d.pixelY))) return !0;
                r = -d.pixelX * o;
              } else {
                if (!(Math.abs(d.pixelY) > Math.abs(d.pixelX))) return !0;
                r = -d.pixelY;
              }
            else
              r =
                Math.abs(d.pixelX) > Math.abs(d.pixelY)
                  ? -d.pixelX * o
                  : -d.pixelY;
            if (0 === r) return !0;
            n.invert && (r = -r);
            let s = p.getTranslate() + r * n.sensitivity;
            if (
              ((s = s >= p.minTranslate() ? p.minTranslate() : s) <=
                p.maxTranslate() && (s = p.maxTranslate()),
              (i =
                !!p.params.loop ||
                !(s === p.minTranslate() || s === p.maxTranslate())) &&
                p.params.nested &&
                l.stopPropagation(),
              p.params.freeMode && p.params.freeMode.enabled)
            ) {
              let a = {
                  time: b(),
                  delta: Math.abs(r),
                  direction: Math.sign(r),
                },
                i =
                  m &&
                  a.time < m.time + 500 &&
                  a.delta <= m.delta &&
                  a.direction === m.direction;
              if (!i) {
                m = void 0;
                let e = p.getTranslate() + r * n.sensitivity,
                  t = p.isBeginning,
                  s = p.isEnd;
                if (
                  ((e = e >= p.minTranslate() ? p.minTranslate() : e) <=
                    p.maxTranslate() && (e = p.maxTranslate()),
                  p.setTransition(0),
                  p.setTranslate(e),
                  p.updateProgress(),
                  p.updateActiveIndex(),
                  p.updateSlidesClasses(),
                  ((!t && p.isBeginning) || (!s && p.isEnd)) &&
                    p.updateSlidesClasses(),
                  p.params.loop &&
                    p.loopFix({
                      direction: a.direction < 0 ? "next" : "prev",
                      byMousewheel: !0,
                    }),
                  p.params.freeMode.sticky)
                ) {
                  clearTimeout(u), (u = void 0), 15 <= h.length && h.shift();
                  let e = h.length ? h[h.length - 1] : void 0,
                    t = h[0];
                  if (
                    (h.push(a),
                    e && (a.delta > e.delta || a.direction !== e.direction))
                  )
                    h.splice(0);
                  else if (
                    15 <= h.length &&
                    a.time - t.time < 500 &&
                    1 <= t.delta - a.delta &&
                    a.delta <= 6
                  ) {
                    let e = 0 < r ? 0.8 : 0.2;
                    (m = a),
                      h.splice(0),
                      (u = w(() => {
                        p.slideToClosest(p.params.speed, !0, void 0, e);
                      }, 0));
                  }
                  u =
                    u ||
                    w(() => {
                      (m = a),
                        h.splice(0),
                        p.slideToClosest(p.params.speed, !0, void 0, 0.5);
                    }, 500);
                }
                if (
                  (i || c("scroll", l),
                  p.params.autoplay &&
                    p.params.autoplayDisableOnInteraction &&
                    p.autoplay.stop(),
                  n.releaseOnEdges &&
                    (e === p.minTranslate() || e === p.maxTranslate()))
                )
                  return !0;
              }
            } else {
              let e = {
                  time: b(),
                  delta: Math.abs(r),
                  direction: Math.sign(r),
                  raw: a,
                },
                t =
                  (2 <= h.length && h.shift(),
                  h.length ? h[h.length - 1] : void 0);
              if (
                (h.push(e),
                (!t ||
                  e.direction !== t.direction ||
                  e.delta > t.delta ||
                  e.time > t.time + 150) &&
                  f(e),
                ((e) => {
                  var t = p.params.mousewheel;
                  if (e.direction < 0) {
                    if (p.isEnd && !p.params.loop && t.releaseOnEdges) return 1;
                  } else if (
                    p.isBeginning &&
                    !p.params.loop &&
                    t.releaseOnEdges
                  )
                    return 1;
                })(e))
              )
                return !0;
            }
            return (
              l.preventDefault ? l.preventDefault() : (l.returnValue = !1), !1
            );
          }
        }
        function o(e) {
          let t = p.el;
          (t =
            "container" !== p.params.mousewheel.eventsTarget
              ? document.querySelector(p.params.mousewheel.eventsTarget)
              : t)[e]("mouseenter", r),
            t[e]("mouseleave", l),
            t[e]("wheel", n);
        }
        function d() {
          return p.params.cssMode
            ? (p.wrapperEl.removeEventListener("wheel", n), !0)
            : !p.mousewheel.enabled &&
                (o("addEventListener"), (p.mousewheel.enabled = !0));
        }
        function v() {
          return p.params.cssMode
            ? (p.wrapperEl.addEventListener(event, n), !0)
            : !!p.mousewheel.enabled &&
                (o("removeEventListener"), !(p.mousewheel.enabled = !1));
        }
        s("init", () => {
          !p.params.mousewheel.enabled && p.params.cssMode && v(),
            p.params.mousewheel.enabled && d();
        }),
          s("destroy", () => {
            p.params.cssMode && d(), p.mousewheel.enabled && v();
          }),
          Object.assign(p.mousewheel, { enable: d, disable: v });
      },
      function (e) {
        let { swiper: l, extendParams: t, on: s, emit: n } = e;
        function i(e) {
          let t;
          return !(
            e &&
            "string" == typeof e &&
            l.isElement &&
            (t = l.el.querySelector(e))
          ) &&
            (e &&
              ("string" == typeof e && (t = [...document.querySelectorAll(e)]),
              l.params.uniqueNavElements &&
              "string" == typeof e &&
              t &&
              1 < t.length &&
              1 === l.el.querySelectorAll(e).length
                ? (t = l.el.querySelector(e))
                : t && 1 === t.length && (t = t[0])),
            e) &&
            !t
            ? e
            : t;
        }
        function a(e, t) {
          let s = l.params.navigation;
          (e = S(e)).forEach((e) => {
            e &&
              (e.classList[t ? "add" : "remove"](...s.disabledClass.split(" ")),
              "BUTTON" === e.tagName && (e.disabled = t),
              l.params.watchOverflow) &&
              l.enabled &&
              e.classList[l.isLocked ? "add" : "remove"](s.lockClass);
          });
        }
        function r() {
          var { nextEl: e, prevEl: t } = l.navigation;
          l.params.loop
            ? (a(t, !1), a(e, !1))
            : (a(t, l.isBeginning && !l.params.rewind),
              a(e, l.isEnd && !l.params.rewind));
        }
        function o(e) {
          e.preventDefault(),
            (l.isBeginning && !l.params.loop && !l.params.rewind) ||
              (l.slidePrev(), n("navigationPrev"));
        }
        function d(e) {
          e.preventDefault(),
            (l.isEnd && !l.params.loop && !l.params.rewind) ||
              (l.slideNext(), n("navigationNext"));
        }
        function p() {
          let s = l.params.navigation;
          if (
            ((l.params.navigation = K(
              l,
              l.originalParams.navigation,
              l.params.navigation,
              { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" },
            )),
            s.nextEl || s.prevEl)
          ) {
            var e = i(s.nextEl),
              a = i(s.prevEl);
            Object.assign(l.navigation, { nextEl: e, prevEl: a }),
              (e = S(e)),
              (a = S(a));
            let t = (e, t) => {
              e && e.addEventListener("click", "next" === t ? d : o),
                !l.enabled && e && e.classList.add(...s.lockClass.split(" "));
            };
            e.forEach((e) => t(e, "next")), a.forEach((e) => t(e, "prev"));
          }
        }
        function c() {
          var { nextEl: e, prevEl: t } = l.navigation,
            e = S(e),
            t = S(t);
          let s = (e, t) => {
            e.removeEventListener("click", "next" === t ? d : o),
              e.classList.remove(
                ...l.params.navigation.disabledClass.split(" "),
              );
          };
          e.forEach((e) => s(e, "next")), t.forEach((e) => s(e, "prev"));
        }
        t({
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled",
          },
        }),
          (l.navigation = { nextEl: null, prevEl: null }),
          s("init", () => {
            (!1 === l.params.navigation.enabled ? u : (p(), r))();
          }),
          s("toEdge fromEdge lock unlock", () => {
            r();
          }),
          s("destroy", () => {
            c();
          }),
          s("enable disable", () => {
            var { nextEl: e, prevEl: t } = l.navigation,
              e = S(e),
              t = S(t);
            l.enabled
              ? r()
              : [...e, ...t]
                  .filter((e) => !!e)
                  .forEach((e) =>
                    e.classList.add(l.params.navigation.lockClass),
                  );
          }),
          s("click", (e, t) => {
            let { nextEl: s, prevEl: a } = l.navigation;
            (s = S(s)), (a = S(a));
            var i = t.target;
            let r = a.includes(i) || s.includes(i);
            if (l.isElement && !r) {
              let e = t.path || (t.composedPath && t.composedPath());
              e && (r = e.find((e) => s.includes(e) || a.includes(e)));
            }
            if (
              l.params.navigation.hideOnClick &&
              !r &&
              (!(
                l.pagination &&
                l.params.pagination &&
                l.params.pagination.clickable
              ) ||
                (l.pagination.el !== i && !l.pagination.el.contains(i)))
            ) {
              let e;
              s.length
                ? (e = s[0].classList.contains(l.params.navigation.hiddenClass))
                : a.length &&
                  (e = a[0].classList.contains(
                    l.params.navigation.hiddenClass,
                  )),
                n(!0 === e ? "navigationShow" : "navigationHide"),
                [...s, ...a]
                  .filter((e) => !!e)
                  .forEach((e) =>
                    e.classList.toggle(l.params.navigation.hiddenClass),
                  );
            }
          });
        let u = () => {
          l.el.classList.add(
            ...l.params.navigation.navigationDisabledClass.split(" "),
          ),
            c();
        };
        Object.assign(l.navigation, {
          enable: () => {
            l.el.classList.remove(
              ...l.params.navigation.navigationDisabledClass.split(" "),
            ),
              p(),
              r();
          },
          disable: u,
          update: r,
          init: p,
          destroy: c,
        });
      },
      function (e) {
        let { swiper: d, extendParams: t, on: s, emit: p } = e;
        e = "swiper-pagination";
        let c,
          u =
            (t({
              pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: (e) => e,
                formatFractionTotal: (e) => e,
                bulletClass: e + "-bullet",
                bulletActiveClass: e + "-bullet-active",
                modifierClass: e + "-",
                currentClass: e + "-current",
                totalClass: e + "-total",
                hiddenClass: e + "-hidden",
                progressbarFillClass: e + "-progressbar-fill",
                progressbarOppositeClass: e + "-progressbar-opposite",
                clickableClass: e + "-clickable",
                lockClass: e + "-lock",
                horizontalClass: e + "-horizontal",
                verticalClass: e + "-vertical",
                paginationDisabledClass: e + "-disabled",
              },
            }),
            (d.pagination = { el: null, bullets: [] }),
            0);
        function i() {
          return (
            !d.params.pagination.el ||
            !d.pagination.el ||
            (Array.isArray(d.pagination.el) && 0 === d.pagination.el.length)
          );
        }
        function m(e, t) {
          var s = d.params.pagination.bulletActiveClass;
          (e =
            e && e[("prev" === t ? "previous" : "next") + "ElementSibling"]) &&
            (e.classList.add(s + "-" + t),
            (e = e[("prev" === t ? "previous" : "next") + "ElementSibling"])) &&
            e.classList.add(s + `-${t}-` + t);
        }
        function a(e) {
          var t = e.target.closest(k(d.params.pagination.bulletClass));
          t &&
            (e.preventDefault(),
            (e = f(t) * d.params.slidesPerGroup),
            d.params.loop
              ? d.realIndex !== e && d.slideToLoop(e)
              : d.slideTo(e));
        }
        function r() {
          let n = d.rtl,
            o = d.params.pagination;
          if (!i()) {
            let l,
              e,
              t = d.pagination.el,
              s =
                ((t = S(t)),
                (d.virtual && d.params.virtual.enabled ? d.virtual : d).slides
                  .length),
              r = d.params.loop
                ? Math.ceil(s / d.params.slidesPerGroup)
                : d.snapGrid.length;
            if (
              (d.params.loop
                ? ((e = d.previousRealIndex || 0),
                  (l =
                    1 < d.params.slidesPerGroup
                      ? Math.floor(d.realIndex / d.params.slidesPerGroup)
                      : d.realIndex))
                : void 0 !== d.snapIndex
                  ? ((l = d.snapIndex), (e = d.previousSnapIndex))
                  : ((e = d.previousIndex || 0), (l = d.activeIndex || 0)),
              "bullets" === o.type &&
                d.pagination.bullets &&
                0 < d.pagination.bullets.length)
            ) {
              let a = d.pagination.bullets,
                s,
                i,
                r;
              if (
                (o.dynamicBullets &&
                  ((c = O(a[0], d.isHorizontal() ? "width" : "height", !0)),
                  t.forEach((e) => {
                    e.style[d.isHorizontal() ? "width" : "height"] =
                      c * (o.dynamicMainBullets + 4) + "px";
                  }),
                  1 < o.dynamicMainBullets &&
                    void 0 !== e &&
                    ((u += l - (e || 0)) > o.dynamicMainBullets - 1
                      ? (u = o.dynamicMainBullets - 1)
                      : u < 0 && (u = 0)),
                  (s = Math.max(l - u, 0)),
                  (i = s + (Math.min(a.length, o.dynamicMainBullets) - 1)),
                  (r = (i + s) / 2)),
                a.forEach((e) => {
                  var t = [
                    ...[
                      "",
                      "-next",
                      "-next-next",
                      "-prev",
                      "-prev-prev",
                      "-main",
                    ].map((e) => "" + o.bulletActiveClass + e),
                  ]
                    .map((e) =>
                      "string" == typeof e && e.includes(" ")
                        ? e.split(" ")
                        : e,
                    )
                    .flat();
                  e.classList.remove(...t);
                }),
                1 < t.length)
              )
                a.forEach((e) => {
                  var t = f(e);
                  t === l
                    ? e.classList.add(...o.bulletActiveClass.split(" "))
                    : d.isElement && e.setAttribute("part", "bullet"),
                    o.dynamicBullets &&
                      (t >= s &&
                        t <= i &&
                        e.classList.add(
                          ...(o.bulletActiveClass + "-main").split(" "),
                        ),
                      t === s && m(e, "prev"),
                      t === i) &&
                      m(e, "next");
                });
              else {
                let e = a[l];
                if (
                  (e && e.classList.add(...o.bulletActiveClass.split(" ")),
                  d.isElement &&
                    a.forEach((e, t) => {
                      e.setAttribute(
                        "part",
                        t === l ? "bullet-active" : "bullet",
                      );
                    }),
                  o.dynamicBullets)
                ) {
                  let e = a[s],
                    t = a[i];
                  for (let e = s; e <= i; e += 1)
                    a[e] &&
                      a[e].classList.add(
                        ...(o.bulletActiveClass + "-main").split(" "),
                      );
                  m(e, "prev"), m(t, "next");
                }
              }
              if (o.dynamicBullets) {
                let e = Math.min(a.length, o.dynamicMainBullets + 4),
                  t = (c * e - c) / 2 - r * c,
                  s = n ? "right" : "left";
                a.forEach((e) => {
                  e.style[d.isHorizontal() ? s : "top"] = t + "px";
                });
              }
            }
            t.forEach((a, e) => {
              if (
                ("fraction" === o.type &&
                  (a.querySelectorAll(k(o.currentClass)).forEach((e) => {
                    e.textContent = o.formatFractionCurrent(l + 1);
                  }),
                  a.querySelectorAll(k(o.totalClass)).forEach((e) => {
                    e.textContent = o.formatFractionTotal(r);
                  })),
                "progressbar" === o.type)
              ) {
                var i = o.progressbarOpposite
                  ? d.isHorizontal()
                    ? "vertical"
                    : "horizontal"
                  : d.isHorizontal()
                    ? "horizontal"
                    : "vertical";
                let e = (l + 1) / r,
                  t = 1,
                  s = 1;
                "horizontal" == i ? (t = e) : (s = e),
                  a.querySelectorAll(k(o.progressbarFillClass)).forEach((e) => {
                    (e.style.transform = `translate3d(0,0,0) scaleX(${t}) scaleY(${s})`),
                      (e.style.transitionDuration = d.params.speed + "ms");
                  });
              }
              "custom" === o.type && o.renderCustom
                ? ((a.innerHTML = o.renderCustom(d, l + 1, r)),
                  0 === e && p("paginationRender", a))
                : (0 === e && p("paginationRender", a),
                  p("paginationUpdate", a)),
                d.params.watchOverflow &&
                  d.enabled &&
                  a.classList[d.isLocked ? "add" : "remove"](o.lockClass);
            });
          }
        }
        function l() {
          let a = d.params.pagination;
          if (!i()) {
            var e =
                d.virtual && d.params.virtual.enabled
                  ? d.virtual.slides.length
                  : d.grid && 1 < d.params.grid.rows
                    ? d.slides.length / Math.ceil(d.params.grid.rows)
                    : d.slides.length,
              t = S((t = d.pagination.el));
            let s = "";
            if ("bullets" === a.type) {
              let t = d.params.loop
                ? Math.ceil(e / d.params.slidesPerGroup)
                : d.snapGrid.length;
              d.params.freeMode &&
                d.params.freeMode.enabled &&
                t > e &&
                (t = e);
              for (let e = 0; e < t; e += 1)
                a.renderBullet
                  ? (s += a.renderBullet.call(d, e, a.bulletClass))
                  : (s += `<${a.bulletElement} ${d.isElement ? 'part="bullet"' : ""} class="${a.bulletClass}"></${a.bulletElement}>`);
            }
            "fraction" === a.type &&
              (s = a.renderFraction
                ? a.renderFraction.call(d, a.currentClass, a.totalClass)
                : `<span class="${a.currentClass}"></span> / <span class="${a.totalClass}"></span>`),
              "progressbar" === a.type &&
                (s = a.renderProgressbar
                  ? a.renderProgressbar.call(d, a.progressbarFillClass)
                  : `<span class="${a.progressbarFillClass}"></span>`),
              (d.pagination.bullets = []),
              t.forEach((e) => {
                "custom" !== a.type && (e.innerHTML = s || ""),
                  "bullets" === a.type &&
                    d.pagination.bullets.push(
                      ...e.querySelectorAll(k(a.bulletClass)),
                    );
              }),
              "custom" !== a.type && p("paginationRender", t[0]);
          }
        }
        function n() {
          d.params.pagination = K(
            d,
            d.originalParams.pagination,
            d.params.pagination,
            { el: "swiper-pagination" },
          );
          let t = d.params.pagination;
          if (t.el) {
            let e;
            (e =
              (e =
                (e =
                  "string" == typeof t.el && d.isElement
                    ? d.el.querySelector(t.el)
                    : e) || "string" != typeof t.el
                  ? e
                  : [...document.querySelectorAll(t.el)]) || t.el) &&
              0 !== e.length &&
              (d.params.uniqueNavElements &&
                "string" == typeof t.el &&
                Array.isArray(e) &&
                1 < e.length &&
                1 < (e = [...d.el.querySelectorAll(t.el)]).length &&
                (e = e.filter((e) => v(e, ".swiper")[0] === d.el)[0]),
              Array.isArray(e) && 1 === e.length && (e = e[0]),
              Object.assign(d.pagination, { el: e }),
              (e = S(e)).forEach((e) => {
                "bullets" === t.type &&
                  t.clickable &&
                  e.classList.add(...(t.clickableClass || "").split(" ")),
                  e.classList.add(t.modifierClass + t.type),
                  e.classList.add(
                    d.isHorizontal() ? t.horizontalClass : t.verticalClass,
                  ),
                  "bullets" === t.type &&
                    t.dynamicBullets &&
                    (e.classList.add(
                      "" + t.modifierClass + t.type + "-dynamic",
                    ),
                    (u = 0),
                    t.dynamicMainBullets < 1) &&
                    (t.dynamicMainBullets = 1),
                  "progressbar" === t.type &&
                    t.progressbarOpposite &&
                    e.classList.add(t.progressbarOppositeClass),
                  t.clickable && e.addEventListener("click", a),
                  d.enabled || e.classList.add(t.lockClass);
              }));
          }
        }
        function o() {
          let t = d.params.pagination;
          var e;
          i() ||
            ((e = d.pagination.el) &&
              (e = S(e)).forEach((e) => {
                e.classList.remove(t.hiddenClass),
                  e.classList.remove(t.modifierClass + t.type),
                  e.classList.remove(
                    d.isHorizontal() ? t.horizontalClass : t.verticalClass,
                  ),
                  t.clickable &&
                    (e.classList.remove(...(t.clickableClass || "").split(" ")),
                    e.removeEventListener("click", a));
              }),
            d.pagination.bullets &&
              d.pagination.bullets.forEach((e) =>
                e.classList.remove(...t.bulletActiveClass.split(" ")),
              ));
        }
        s("changeDirection", () => {
          if (d.pagination && d.pagination.el) {
            let t = d.params.pagination;
            var e = d.pagination.el;
            (e = S(e)).forEach((e) => {
              e.classList.remove(t.horizontalClass, t.verticalClass),
                e.classList.add(
                  d.isHorizontal() ? t.horizontalClass : t.verticalClass,
                );
            });
          }
        }),
          s("init", () => {
            (!1 === d.params.pagination.enabled ? h : (n(), l(), r))();
          }),
          s("activeIndexChange", () => {
            void 0 === d.snapIndex && r();
          }),
          s("snapIndexChange", () => {
            r();
          }),
          s("snapGridLengthChange", () => {
            l(), r();
          }),
          s("destroy", () => {
            o();
          }),
          s("enable disable", () => {
            var e = d.pagination.el;
            e &&
              (e = S(e)).forEach((e) =>
                e.classList[d.enabled ? "remove" : "add"](
                  d.params.pagination.lockClass,
                ),
              );
          }),
          s("lock unlock", () => {
            r();
          }),
          s("click", (e, t) => {
            var t = t.target,
              s = S(d.pagination.el);
            if (
              d.params.pagination.el &&
              d.params.pagination.hideOnClick &&
              s &&
              0 < s.length &&
              !t.classList.contains(d.params.pagination.bulletClass) &&
              (!d.navigation ||
                !(
                  (d.navigation.nextEl && t === d.navigation.nextEl) ||
                  (d.navigation.prevEl && t === d.navigation.prevEl)
                ))
            ) {
              let e = s[0].classList.contains(d.params.pagination.hiddenClass);
              p(!0 === e ? "paginationShow" : "paginationHide"),
                s.forEach((e) =>
                  e.classList.toggle(d.params.pagination.hiddenClass),
                );
            }
          });
        let h = () => {
          d.el.classList.add(d.params.pagination.paginationDisabledClass);
          var e = d.pagination.el;
          e &&
            (e = S(e)).forEach((e) =>
              e.classList.add(d.params.pagination.paginationDisabledClass),
            ),
            o();
        };
        Object.assign(d.pagination, {
          enable: () => {
            d.el.classList.remove(d.params.pagination.paginationDisabledClass);
            var e = d.pagination.el;
            e &&
              (e = S(e)).forEach((e) =>
                e.classList.remove(d.params.pagination.paginationDisabledClass),
              ),
              n(),
              l(),
              r();
          },
          disable: h,
          render: l,
          update: r,
          init: n,
          destroy: o,
        });
      },
      function (e) {
        let { swiper: p, extendParams: t, on: s } = e,
          r =
            (t({ parallax: { enabled: !1 } }),
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"),
          l = (t, s) => {
            var e = p.rtl,
              e = e ? -1 : 1,
              a = t.getAttribute("data-swiper-parallax") || "0";
            let i = t.getAttribute("data-swiper-parallax-x"),
              r = t.getAttribute("data-swiper-parallax-y");
            var l = t.getAttribute("data-swiper-parallax-scale"),
              n = t.getAttribute("data-swiper-parallax-opacity"),
              o = t.getAttribute("data-swiper-parallax-rotate");
            if (
              (i || r
                ? ((i = i || "0"), (r = r || "0"))
                : p.isHorizontal()
                  ? ((i = a), (r = "0"))
                  : ((r = a), (i = "0")),
              (i =
                0 <= i.indexOf("%")
                  ? parseInt(i, 10) * s * e + "%"
                  : i * s * e + "px"),
              (r =
                0 <= r.indexOf("%") ? parseInt(r, 10) * s + "%" : r * s + "px"),
              null != n)
            ) {
              let e = n - (n - 1) * (1 - Math.abs(s));
              t.style.opacity = e;
            }
            let d = `translate3d(${i}, ${r}, 0px)`;
            null != l && (d += ` scale(${l - (l - 1) * (1 - Math.abs(s))})`),
              o && null != o && (d += ` rotate(${o * s * -1}deg)`),
              (t.style.transform = d);
          },
          a = () => {
            let { el: e, slides: t, progress: a, snapGrid: i } = p,
              s = A(e, r);
            p.isElement && s.push(...A(p.hostEl, r)),
              s.forEach((e) => {
                l(e, a);
              }),
              t.forEach((e, t) => {
                let s = e.progress;
                1 < p.params.slidesPerGroup &&
                  "auto" !== p.params.slidesPerView &&
                  (s += Math.ceil(t / 2) - a * (i.length - 1)),
                  (s = Math.min(Math.max(s, -1), 1)),
                  e
                    .querySelectorAll(r + ", [data-swiper-parallax-rotate]")
                    .forEach((e) => {
                      l(e, s);
                    });
              });
          };
        s("beforeInit", () => {
          p.params.parallax.enabled &&
            ((p.params.watchSlidesProgress = !0),
            (p.originalParams.watchSlidesProgress = !0));
        }),
          s("init", () => {
            p.params.parallax.enabled && a();
          }),
          s("setTranslate", () => {
            p.params.parallax.enabled && a();
          }),
          s("setTransition", (e, t) => {
            var s, a;
            p.params.parallax.enabled &&
              (({ el: t, hostEl: a } =
                (void 0 === (s = t) && (s = p.params.speed), p)),
              (t = [...t.querySelectorAll(r)]),
              p.isElement && t.push(...a.querySelectorAll(r)),
              t.forEach((e) => {
                let t =
                  parseInt(
                    e.getAttribute("data-swiper-parallax-duration"),
                    10,
                  ) || s;
                0 === s && (t = 0), (e.style.transitionDuration = t + "ms");
              }));
          });
      },
      function (e) {
        let { swiper: n, extendParams: t, on: s } = e;
        function o(e, t) {
          let s = (() => {
              let s, a, i;
              return (e, t) => {
                for (a = -1, s = e.length; 1 < s - a; )
                  e[(i = (s + a) >> 1)] <= t ? (a = i) : (s = i);
                return s;
              };
            })(),
            a,
            i;
          return (
            (this.x = e),
            (this.y = t),
            (this.lastIndex = e.length - 1),
            (this.interpolate = function (e) {
              return e
                ? ((i = s(this.x, e)),
                  (a = i - 1),
                  ((e - this.x[a]) * (this.y[i] - this.y[a])) /
                    (this.x[i] - this.x[a]) +
                    this.y[a])
                : 0;
            }),
            this
          );
        }
        function a() {
          n.controller.control &&
            n.controller.spline &&
            ((n.controller.spline = void 0), delete n.controller.spline);
        }
        t({ controller: { control: void 0, inverse: !1, by: "slide" } }),
          (n.controller = { control: void 0 }),
          s("beforeInit", () => {
            if (
              "undefined" != typeof window &&
              ("string" == typeof n.params.controller.control ||
                n.params.controller.control instanceof HTMLElement)
            ) {
              let s = document.querySelector(n.params.controller.control);
              if (s && s.swiper) n.controller.control = s.swiper;
              else if (s) {
                let t = (e) => {
                  (n.controller.control = e.detail[0]),
                    n.update(),
                    s.removeEventListener("init", t);
                };
                s.addEventListener("init", t);
              }
            } else n.controller.control = n.params.controller.control;
          }),
          s("update", () => {
            a();
          }),
          s("resize", () => {
            a();
          }),
          s("observerUpdate", () => {
            a();
          }),
          s("setTranslate", (e, t, s) => {
            n.controller.control &&
              !n.controller.control.destroyed &&
              n.controller.setTranslate(t, s);
          }),
          s("setTransition", (e, t, s) => {
            n.controller.control &&
              !n.controller.control.destroyed &&
              n.controller.setTransition(t, s);
          }),
          Object.assign(n.controller, {
            setTranslate: function (e, t) {
              var s = n.controller.control;
              let a, i;
              var r = n.constructor;
              function l(e) {
                var t, s;
                e.destroyed ||
                  ((t = n.rtlTranslate ? -n.translate : n.translate),
                  "slide" === n.params.controller.by &&
                    ((s = e),
                    (n.controller.spline = n.params.loop
                      ? new o(n.slidesGrid, s.slidesGrid)
                      : new o(n.snapGrid, s.snapGrid)),
                    (i = -n.controller.spline.interpolate(-t))),
                  (i && "container" !== n.params.controller.by) ||
                    ((a =
                      (e.maxTranslate() - e.minTranslate()) /
                      (n.maxTranslate() - n.minTranslate())),
                    (!Number.isNaN(a) && Number.isFinite(a)) || (a = 1),
                    (i = (t - n.minTranslate()) * a + e.minTranslate())),
                  n.params.controller.inverse && (i = e.maxTranslate() - i),
                  e.updateProgress(i),
                  e.setTranslate(i, n),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses());
              }
              if (Array.isArray(s))
                for (let e = 0; e < s.length; e += 1)
                  s[e] !== t && s[e] instanceof r && l(s[e]);
              else s instanceof r && t !== s && l(s);
            },
            setTransition: function (t, e) {
              let s = n.constructor,
                a = n.controller.control,
                i;
              function r(e) {
                e.destroyed ||
                  (e.setTransition(t, n),
                  0 !== t &&
                    (e.transitionStart(),
                    e.params.autoHeight &&
                      w(() => {
                        e.updateAutoHeight();
                      }),
                    x(e.wrapperEl, () => {
                      a && e.transitionEnd();
                    })));
              }
              if (Array.isArray(a))
                for (i = 0; i < a.length; i += 1)
                  a[i] !== e && a[i] instanceof s && r(a[i]);
              else a instanceof s && e !== a && r(a);
            },
          });
      },
      function (e) {
        let r,
          l,
          { swiper: n, extendParams: t, on: s, emit: o, params: a } = e;
        (n.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
          t({
            autoplay: {
              enabled: !1,
              delay: 3e3,
              waitForTransition: !0,
              disableOnInteraction: !1,
              stopOnLastSlide: !1,
              reverseDirection: !1,
              pauseOnMouseEnter: !1,
            },
          });
        let d,
          i,
          p,
          c,
          u,
          m,
          h,
          f,
          v = a && a.autoplay ? a.autoplay.delay : 3e3,
          g = a && a.autoplay ? a.autoplay.delay : 3e3,
          w = new Date().getTime();
        function b(e) {
          n &&
            !n.destroyed &&
            n.wrapperEl &&
            e.target === n.wrapperEl &&
            (n.wrapperEl.removeEventListener("transitionend", b),
            f || (e.detail && e.detail.bySwiperTouchMove) || M());
        }
        let y = () => {
            var e;
            !n.destroyed &&
              n.autoplay.running &&
              (n.autoplay.paused ? (i = !0) : i && ((g = d), (i = !1)),
              (e = n.autoplay.paused ? d : w + g - new Date().getTime()),
              (n.autoplay.timeLeft = e),
              o("autoplayTimeLeft", e, e / v),
              (l = requestAnimationFrame(() => {
                y();
              })));
          },
          T = (a) => {
            if (!n.destroyed && n.autoplay.running) {
              cancelAnimationFrame(l), y();
              let e = void 0 === a ? n.params.autoplay.delay : a;
              (v = n.params.autoplay.delay), (g = n.params.autoplay.delay);
              var i = (() => {
                var e =
                  n.virtual && n.params.virtual.enabled
                    ? n.slides.filter((e) =>
                        e.classList.contains("swiper-slide-active"),
                      )[0]
                    : n.slides[n.activeIndex];
                if (e)
                  return parseInt(e.getAttribute("data-swiper-autoplay"), 10);
              })();
              !Number.isNaN(i) &&
                0 < i &&
                void 0 === a &&
                ((e = i), (v = i), (g = i)),
                (d = e);
              let t = n.params.speed,
                s = () => {
                  n &&
                    !n.destroyed &&
                    (n.params.autoplay.reverseDirection
                      ? !n.isBeginning || n.params.loop || n.params.rewind
                        ? (n.slidePrev(t, !0, !0), o("autoplay"))
                        : n.params.autoplay.stopOnLastSlide ||
                          (n.slideTo(n.slides.length - 1, t, !0, !0),
                          o("autoplay"))
                      : !n.isEnd || n.params.loop || n.params.rewind
                        ? (n.slideNext(t, !0, !0), o("autoplay"))
                        : n.params.autoplay.stopOnLastSlide ||
                          (n.slideTo(0, t, !0, !0), o("autoplay")),
                    n.params.cssMode) &&
                    ((w = new Date().getTime()),
                    requestAnimationFrame(() => {
                      T();
                    }));
                };
              return (
                0 < e
                  ? (clearTimeout(r),
                    (r = setTimeout(() => {
                      s();
                    }, e)))
                  : requestAnimationFrame(() => {
                      s();
                    }),
                e
              );
            }
          },
          x = () => {
            (w = new Date().getTime()),
              (n.autoplay.running = !0),
              T(),
              o("autoplayStart");
          },
          S = () => {
            (n.autoplay.running = !1),
              clearTimeout(r),
              cancelAnimationFrame(l),
              o("autoplayStop");
          },
          E = (e, t) => {
            !n.destroyed &&
              n.autoplay.running &&
              (clearTimeout(r),
              e || (h = !0),
              (e = () => {
                o("autoplayPause"),
                  n.params.autoplay.waitForTransition
                    ? n.wrapperEl.addEventListener("transitionend", b)
                    : M();
              }),
              (n.autoplay.paused = !0),
              t
                ? (m && (d = n.params.autoplay.delay), (m = !1), e())
                : ((t = d || n.params.autoplay.delay),
                  (d = t - (new Date().getTime() - w)),
                  (n.isEnd && d < 0 && !n.params.loop) ||
                    (d < 0 && (d = 0), e())));
          },
          M = () => {
            (n.isEnd && d < 0 && !n.params.loop) ||
              n.destroyed ||
              !n.autoplay.running ||
              ((w = new Date().getTime()),
              h ? ((h = !1), T(d)) : T(),
              (n.autoplay.paused = !1),
              o("autoplayResume"));
          },
          C = () => {
            var e;
            !n.destroyed &&
              n.autoplay.running &&
              ("hidden" === (e = I()).visibilityState && ((h = !0), E(!0)),
              "visible" === e.visibilityState) &&
              M();
          },
          P = (e) => {
            "mouse" === e.pointerType &&
              ((h = !0), (f = !0), n.animating || n.autoplay.paused || E(!0));
          },
          L = (e) => {
            "mouse" === e.pointerType && ((f = !1), n.autoplay.paused) && M();
          };
        s("init", () => {
          n.params.autoplay.enabled &&
            (n.params.autoplay.pauseOnMouseEnter &&
              (n.el.addEventListener("pointerenter", P),
              n.el.addEventListener("pointerleave", L)),
            I().addEventListener("visibilitychange", C),
            x());
        }),
          s("destroy", () => {
            n.el &&
              "string" != typeof n.el &&
              (n.el.removeEventListener("pointerenter", P),
              n.el.removeEventListener("pointerleave", L)),
              I().removeEventListener("visibilitychange", C),
              n.autoplay.running && S();
          }),
          s("_freeModeStaticRelease", () => {
            (c || h) && M();
          }),
          s("_freeModeNoMomentumRelease", () => {
            n.params.autoplay.disableOnInteraction ? S() : E(!0, !0);
          }),
          s("beforeTransitionStart", (e, t, s) => {
            !n.destroyed &&
              n.autoplay.running &&
              (s || !n.params.autoplay.disableOnInteraction ? E(!0, !0) : S());
          }),
          s("sliderFirstMove", () => {
            !n.destroyed &&
              n.autoplay.running &&
              (n.params.autoplay.disableOnInteraction
                ? S()
                : ((p = !0),
                  (c = !1),
                  (h = !1),
                  (u = setTimeout(() => {
                    (h = !0), (c = !0), E(!0);
                  }, 200))));
          }),
          s("touchEnd", () => {
            !n.destroyed &&
              n.autoplay.running &&
              p &&
              (clearTimeout(u),
              clearTimeout(r),
              (p =
                ((c =
                  (n.params.autoplay.disableOnInteraction ||
                    (c && n.params.cssMode && M()),
                  !1)),
                !1)));
          }),
          s("slideChange", () => {
            !n.destroyed && n.autoplay.running && (m = !0);
          }),
          Object.assign(n.autoplay, { start: x, stop: S, pause: E, resume: M });
      },
      function (e) {
        let { swiper: o, extendParams: t, on: s } = e,
          a =
            (t({
              thumbs: {
                swiper: null,
                multipleActiveThumbs: !0,
                autoScrollOffset: 0,
                slideThumbActiveClass: "swiper-slide-thumb-active",
                thumbsContainerClass: "swiper-thumbs",
              },
            }),
            !1),
          i = !1;
        function r() {
          var e,
            t,
            s = o.thumbs.swiper;
          !s ||
            s.destroyed ||
            ((e = s.clickedIndex),
            (t = s.clickedSlide) &&
              t.classList.contains(o.params.thumbs.slideThumbActiveClass)) ||
            (null != e &&
              ((t = s.params.loop
                ? parseInt(
                    s.clickedSlide.getAttribute("data-swiper-slide-index"),
                    10,
                  )
                : e),
              o.params.loop ? o.slideToLoop(t) : o.slideTo(t)));
        }
        function l() {
          var e = o.params.thumbs;
          if (a) return !1;
          a = !0;
          var t = o.constructor;
          return (
            e.swiper instanceof t
              ? ((o.thumbs.swiper = e.swiper),
                Object.assign(o.thumbs.swiper.originalParams, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                Object.assign(o.thumbs.swiper.params, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                o.thumbs.swiper.update())
              : d(e.swiper) &&
                ((e = Object.assign({}, e.swiper)),
                Object.assign(e, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                (o.thumbs.swiper = new t(e)),
                (i = !0)),
            o.thumbs.swiper.el.classList.add(
              o.params.thumbs.thumbsContainerClass,
            ),
            o.thumbs.swiper.on("tap", r),
            !0
          );
        }
        function n(a) {
          var i = o.thumbs.swiper;
          if (i && !i.destroyed) {
            var r =
              "auto" === i.params.slidesPerView
                ? i.slidesPerViewDynamic()
                : i.params.slidesPerView;
            let t = 1,
              s = o.params.thumbs.slideThumbActiveClass;
            if (
              (1 < o.params.slidesPerView &&
                !o.params.centeredSlides &&
                (t = o.params.slidesPerView),
              o.params.thumbs.multipleActiveThumbs || (t = 1),
              (t = Math.floor(t)),
              i.slides.forEach((e) => e.classList.remove(s)),
              i.params.loop || (i.params.virtual && i.params.virtual.enabled))
            )
              for (let e = 0; e < t; e += 1)
                A(
                  i.slidesEl,
                  `[data-swiper-slide-index="${o.realIndex + e}"]`,
                ).forEach((e) => {
                  e.classList.add(s);
                });
            else
              for (let e = 0; e < t; e += 1)
                i.slides[o.realIndex + e] &&
                  i.slides[o.realIndex + e].classList.add(s);
            var l = o.params.thumbs.autoScrollOffset,
              n = l && !i.params.loop;
            if (o.realIndex !== i.realIndex || n) {
              let e = i.activeIndex,
                t,
                s;
              if (i.params.loop) {
                let e = i.slides.filter(
                  (e) =>
                    e.getAttribute("data-swiper-slide-index") ===
                    "" + o.realIndex,
                )[0];
                (t = i.slides.indexOf(e)),
                  (s = o.activeIndex > o.previousIndex ? "next" : "prev");
              } else
                (t = o.realIndex), (s = t > o.previousIndex ? "next" : "prev");
              n && (t += "next" === s ? l : -1 * l),
                i.visibleSlidesIndexes &&
                  i.visibleSlidesIndexes.indexOf(t) < 0 &&
                  (i.params.centeredSlides
                    ? (t =
                        t > e
                          ? t - Math.floor(r / 2) + 1
                          : t + Math.floor(r / 2) - 1)
                    : t > e && i.params.slidesPerGroup,
                  i.slideTo(t, a ? 0 : void 0));
            }
          }
        }
        (o.thumbs = { swiper: null }),
          s("beforeInit", () => {
            let a = o.params.thumbs;
            if (a && a.swiper)
              if (
                "string" == typeof a.swiper ||
                a.swiper instanceof HTMLElement
              ) {
                let e = I(),
                  t = () => {
                    o.destroyed ||
                      (() => {
                        let s =
                          "string" == typeof a.swiper
                            ? e.querySelector(a.swiper)
                            : a.swiper;
                        if (s && s.swiper) (a.swiper = s.swiper), l(), n(!0);
                        else if (s) {
                          let t = (e) => {
                            (a.swiper = e.detail[0]),
                              s.removeEventListener("init", t),
                              l(),
                              n(!0),
                              a.swiper.update(),
                              o.update();
                          };
                          s.addEventListener("init", t);
                        }
                        return s;
                      })() ||
                      requestAnimationFrame(t);
                  };
                requestAnimationFrame(t);
              } else l(), n(!0);
          }),
          s("slideChange update resize observerUpdate", () => {
            n();
          }),
          s("setTransition", (e, t) => {
            var s = o.thumbs.swiper;
            s && !s.destroyed && s.setTransition(t);
          }),
          s("beforeDestroy", () => {
            var e = o.thumbs.swiper;
            e && !e.destroyed && i && e.destroy();
          }),
          Object.assign(o.thumbs, { init: l, update: n });
      },
      function (e) {
        let { swiper: u, extendParams: t, emit: m, once: h } = e;
        t({
          freeMode: {
            enabled: !1,
            momentum: !0,
            momentumRatio: 1,
            momentumBounce: !0,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: !1,
            minimumVelocity: 0.02,
          },
        }),
          Object.assign(u, {
            freeMode: {
              onTouchStart: function () {
                var e;
                u.params.cssMode ||
                  ((e = u.getTranslate()),
                  u.setTranslate(e),
                  u.setTransition(0),
                  (u.touchEventsData.velocities.length = 0),
                  u.freeMode.onTouchEnd({
                    currentPos: u.rtl ? u.translate : -u.translate,
                  }));
              },
              onTouchMove: function () {
                var e, t;
                u.params.cssMode ||
                  (({ touchEventsData: e, touches: t } = u),
                  0 === e.velocities.length &&
                    e.velocities.push({
                      position: t[u.isHorizontal() ? "startX" : "startY"],
                      time: e.touchStartTime,
                    }),
                  e.velocities.push({
                    position: t[u.isHorizontal() ? "currentX" : "currentY"],
                    time: b(),
                  }));
              },
              onTouchEnd: function (c) {
                let t = c.currentPos;
                if (!u.params.cssMode) {
                  let {
                      params: l,
                      wrapperEl: n,
                      rtlTranslate: o,
                      snapGrid: d,
                      touchEventsData: p,
                    } = u,
                    e = b() - p.touchStartTime;
                  if (t < -u.minTranslate()) u.slideTo(u.activeIndex);
                  else if (t > -u.maxTranslate())
                    u.slides.length < d.length
                      ? u.slideTo(d.length - 1)
                      : u.slideTo(u.slides.length - 1);
                  else {
                    if (l.freeMode.momentum) {
                      if (1 < p.velocities.length) {
                        let e = p.velocities.pop(),
                          t = p.velocities.pop(),
                          s = e.position - t.position,
                          a = e.time - t.time;
                        (u.velocity = s / a),
                          (u.velocity /= 2),
                          Math.abs(u.velocity) < l.freeMode.minimumVelocity &&
                            (u.velocity = 0),
                          (150 < a || 300 < b() - e.time) && (u.velocity = 0);
                      } else u.velocity = 0;
                      (u.velocity *= l.freeMode.momentumVelocityRatio),
                        (p.velocities.length = 0);
                      let s = 1e3 * l.freeMode.momentumRatio,
                        e = u.velocity * s,
                        a = u.translate + e;
                      o && (a = -a);
                      let t,
                        i = !1;
                      c =
                        20 *
                        Math.abs(u.velocity) *
                        l.freeMode.momentumBounceRatio;
                      let r;
                      if (a < u.maxTranslate())
                        l.freeMode.momentumBounce
                          ? (a + u.maxTranslate() < -c &&
                              (a = u.maxTranslate() - c),
                            (t = u.maxTranslate()),
                            (i = !0),
                            (p.allowMomentumBounce = !0))
                          : (a = u.maxTranslate()),
                          l.loop && l.centeredSlides && (r = !0);
                      else if (a > u.minTranslate())
                        l.freeMode.momentumBounce
                          ? (a - u.minTranslate() > c &&
                              (a = u.minTranslate() + c),
                            (t = u.minTranslate()),
                            (i = !0),
                            (p.allowMomentumBounce = !0))
                          : (a = u.minTranslate()),
                          l.loop && l.centeredSlides && (r = !0);
                      else if (l.freeMode.sticky) {
                        let t;
                        for (let e = 0; e < d.length; e += 1)
                          if (d[e] > -a) {
                            t = e;
                            break;
                          }
                        a = -(a =
                          Math.abs(d[t] - a) < Math.abs(d[t - 1] - a) ||
                          "next" === u.swipeDirection
                            ? d[t]
                            : d[t - 1]);
                      }
                      if (
                        (r &&
                          h("transitionEnd", () => {
                            u.loopFix();
                          }),
                        0 !== u.velocity)
                      ) {
                        if (
                          ((s = o
                            ? Math.abs((-a - u.translate) / u.velocity)
                            : Math.abs((a - u.translate) / u.velocity)),
                          l.freeMode.sticky)
                        ) {
                          let e = Math.abs((o ? -a : a) - u.translate),
                            t = u.slidesSizesGrid[u.activeIndex];
                          s =
                            e < t
                              ? l.speed
                              : e < 2 * t
                                ? 1.5 * l.speed
                                : 2.5 * l.speed;
                        }
                      } else if (l.freeMode.sticky)
                        return void u.slideToClosest();
                      l.freeMode.momentumBounce && i
                        ? (u.updateProgress(t),
                          u.setTransition(s),
                          u.setTranslate(a),
                          u.transitionStart(!0, u.swipeDirection),
                          (u.animating = !0),
                          x(n, () => {
                            u &&
                              !u.destroyed &&
                              p.allowMomentumBounce &&
                              (m("momentumBounce"),
                              u.setTransition(l.speed),
                              setTimeout(() => {
                                u.setTranslate(t),
                                  x(n, () => {
                                    u && !u.destroyed && u.transitionEnd();
                                  });
                              }, 0));
                          }))
                        : u.velocity
                          ? (m("_freeModeNoMomentumRelease"),
                            u.updateProgress(a),
                            u.setTransition(s),
                            u.setTranslate(a),
                            u.transitionStart(!0, u.swipeDirection),
                            u.animating ||
                              ((u.animating = !0),
                              x(n, () => {
                                u && !u.destroyed && u.transitionEnd();
                              })))
                          : u.updateProgress(a),
                        u.updateActiveIndex(),
                        u.updateSlidesClasses();
                    } else {
                      if (l.freeMode.sticky) return void u.slideToClosest();
                      l.freeMode && m("_freeModeNoMomentumRelease");
                    }
                    (!l.freeMode.momentum || e >= l.longSwipesMs) &&
                      (m("_freeModeStaticRelease"),
                      u.updateProgress(),
                      u.updateActiveIndex(),
                      u.updateSlidesClasses());
                  }
                }
              },
            },
          });
      },
      function (e) {
        let { swiper: l, extendParams: t, on: s } = e;
        t({ fadeEffect: { crossFade: !1 } }),
          z({
            effect: "fade",
            swiper: l,
            on: s,
            setTranslate: () => {
              let e = l.slides;
              l.params.fadeEffect;
              for (let a = 0; a < e.length; a += 1) {
                let e = l.slides[a],
                  t = -e.swiperSlideOffset,
                  s = (l.params.virtualTranslate || (t -= l.translate), 0);
                l.isHorizontal() || ((s = t), (t = 0));
                var i = l.params.fadeEffect.crossFade
                    ? Math.max(1 - Math.abs(e.progress), 0)
                    : 1 + Math.min(Math.max(e.progress, -1), 0),
                  r = D(0, e);
                (r.style.opacity = i),
                  (r.style.transform = `translate3d(${t}px, ${s}px, 0px)`);
              }
            },
            setTransition: (t) => {
              var e = l.slides.map((e) => r(e));
              e.forEach((e) => {
                e.style.transitionDuration = t + "ms";
              }),
                Z({
                  swiper: l,
                  duration: t,
                  transformElements: e,
                  allSlides: !0,
                });
            },
            overwriteParams: () => ({
              slidesPerView: 1,
              slidesPerGroup: 1,
              watchSlidesProgress: !0,
              spaceBetween: 0,
              virtualTranslate: !l.params.cssMode,
            }),
          });
      },
      function (e) {
        let { swiper: y, extendParams: t, on: s } = e;
        t({
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: !0,
          },
        }),
          z({
            effect: "coverflow",
            swiper: y,
            on: s,
            setTranslate: () => {
              let { width: e, height: t, slides: u, slidesSizesGrid: m } = y,
                h = y.params.coverflowEffect,
                f = y.isHorizontal(),
                s = y.translate,
                v = f ? e / 2 - s : t / 2 - s,
                g = f ? h.rotate : -h.rotate,
                w = h.depth;
              for (let c = 0, e = u.length; c < e; c += 1) {
                let s = u[c],
                  e = m[c],
                  t = (v - s.swiperSlideOffset - e / 2) / e,
                  a =
                    "function" == typeof h.modifier
                      ? h.modifier(t)
                      : t * h.modifier,
                  i = f ? g * a : 0,
                  r = f ? 0 : g * a,
                  l = -w * Math.abs(a),
                  n = h.stretch,
                  o =
                    ("string" == typeof n &&
                      -1 !== n.indexOf("%") &&
                      (n = (parseFloat(h.stretch) / 100) * e),
                    f ? 0 : n * a),
                  d = f ? n * a : 0,
                  p = 1 - (1 - h.scale) * Math.abs(a);
                Math.abs(d) < 0.001 && (d = 0),
                  Math.abs(o) < 0.001 && (o = 0),
                  Math.abs(l) < 0.001 && (l = 0),
                  Math.abs(i) < 0.001 && (i = 0),
                  Math.abs(r) < 0.001 && (r = 0),
                  Math.abs(p) < 0.001 && (p = 0),
                  y.browser &&
                    y.browser.need3dFix &&
                    ((Math.abs(i) / 90) % 2 == 1 && (i += 0.001),
                    (Math.abs(r) / 90) % 2 == 1) &&
                    (r += 0.001);
                var b = `translate3d(${d}px,${o}px,${l}px)  rotateX(${r}deg) rotateY(${i}deg) scale(${p})`;
                if (
                  ((D(0, s).style.transform = b),
                  (s.style.zIndex = 1 - Math.abs(Math.round(a))),
                  h.slideShadows)
                ) {
                  let e = f
                      ? s.querySelector(".swiper-slide-shadow-left")
                      : s.querySelector(".swiper-slide-shadow-top"),
                    t = f
                      ? s.querySelector(".swiper-slide-shadow-right")
                      : s.querySelector(".swiper-slide-shadow-bottom");
                  (e = e || G("coverflow", s, f ? "left" : "top")),
                    (t = t || G("coverflow", s, f ? "right" : "bottom")),
                    e && (e.style.opacity = 0 < a ? a : 0),
                    t && (t.style.opacity = 0 < -a ? -a : 0);
                }
              }
            },
            setTransition: (t) => {
              y.slides
                .map((e) => r(e))
                .forEach((e) => {
                  (e.style.transitionDuration = t + "ms"),
                    e
                      .querySelectorAll(
                        ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left",
                      )
                      .forEach((e) => {
                        e.style.transitionDuration = t + "ms";
                      });
                });
            },
            perspective: () => !0,
            overwriteParams: () => ({ watchSlidesProgress: !0 }),
          });
      },
      function (e) {
        let { swiper: w, extendParams: t, on: s } = e;
        t({
          creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: !1,
            progressMultiplier: 1,
            perspective: !0,
            prev: {
              translate: [0, 0, 0],
              rotate: [0, 0, 0],
              opacity: 1,
              scale: 1,
            },
            next: {
              translate: [0, 0, 0],
              rotate: [0, 0, 0],
              opacity: 1,
              scale: 1,
            },
          },
        });
        z({
          effect: "creative",
          swiper: w,
          on: s,
          setTranslate: () => {
            let { slides: p, wrapperEl: t, slidesSizesGrid: s } = w,
              c = w.params.creativeEffect,
              u = c.progressMultiplier,
              m = w.params.centeredSlides;
            if (m) {
              let e = s[0] / 2 - w.params.slidesOffsetBefore || 0;
              t.style.transform = `translateX(calc(50% - ${e}px))`;
            }
            for (let d = 0; d < p.length; d += 1) {
              let e = p[d],
                t = e.progress,
                a = Math.min(
                  Math.max(e.progress, -c.limitProgress),
                  c.limitProgress,
                ),
                s = a,
                i =
                  (m ||
                    (s = Math.min(
                      Math.max(e.originalProgress, -c.limitProgress),
                      c.limitProgress,
                    )),
                  e.swiperSlideOffset),
                r = [w.params.cssMode ? -i - w.translate : -i, 0, 0],
                l = [0, 0, 0],
                n = !1,
                o =
                  (w.isHorizontal() || ((r[1] = r[0]), (r[0] = 0)),
                  {
                    translate: [0, 0, 0],
                    rotate: [0, 0, 0],
                    scale: 1,
                    opacity: 1,
                  });
              a < 0
                ? ((o = c.next), (n = !0))
                : 0 < a && ((o = c.prev), (n = !0)),
                r.forEach((e, t) => {
                  r[t] =
                    `calc(${e}px + (${((e = o.translate[t]), "string" == typeof e ? e : e + "px")} * ${Math.abs(a * u)}))`;
                }),
                l.forEach((e, t) => {
                  let s = o.rotate[t] * Math.abs(a * u);
                  w.browser &&
                    w.browser.need3dFix &&
                    (Math.abs(s) / 90) % 2 == 1 &&
                    (s += 0.001),
                    (l[t] = s);
                }),
                (e.style.zIndex = -Math.abs(Math.round(t)) + p.length);
              var h = r.join(", "),
                f = `rotateX(${l[0]}deg) rotateY(${l[1]}deg) rotateZ(${l[2]}deg)`,
                v =
                  s < 0
                    ? `scale(${1 + (1 - o.scale) * s * u})`
                    : `scale(${1 - (1 - o.scale) * s * u})`,
                g =
                  s < 0
                    ? 1 + (1 - o.opacity) * s * u
                    : 1 - (1 - o.opacity) * s * u,
                h = `translate3d(${h}) ${f} ` + v;
              if ((n && o.shadow) || !n) {
                let t = e.querySelector(".swiper-slide-shadow");
                if ((t = !t && o.shadow ? G("creative", e) : t)) {
                  let e = c.shadowPerProgress ? a * (1 / c.limitProgress) : a;
                  t.style.opacity = Math.min(Math.max(Math.abs(e), 0), 1);
                }
              }
              f = D(0, e);
              (f.style.transform = h),
                (f.style.opacity = g),
                o.origin && (f.style.transformOrigin = o.origin);
            }
          },
          setTransition: (t) => {
            var e = w.slides.map((e) => r(e));
            e.forEach((e) => {
              (e.style.transitionDuration = t + "ms"),
                e.querySelectorAll(".swiper-slide-shadow").forEach((e) => {
                  e.style.transitionDuration = t + "ms";
                });
            }),
              Z({
                swiper: w,
                duration: t,
                transformElements: e,
                allSlides: !0,
              });
          },
          perspective: () => w.params.creativeEffect.perspective,
          overwriteParams: () => ({
            watchSlidesProgress: !0,
            virtualTranslate: !w.params.cssMode,
          }),
        });
      },
    ]),
    M
  );
})();
